{
  "booking": {
    "title": "Buchungen",
    "description": "Verwalten und bestätigen Sie Buchungen. Bestätigte Buchungen erscheinen im Kalender unten.",
    "stats": {
      "totalBookings": "Gesamte Buchungen",
      "pending": "Ausstehend",
      "confirmed": "Bestätigt",
      "upcomingToday": "Heute bevorstehend"
    },
    "table": {
      "booking": "Buchung",
      "customer": "Kunde",
      "resource": "Ressource",
      "dateTime": "Datum & Uhrzeit",
      "status": "Status",
      "actions": "Aktionen",
      "party": "Gruppe: {{size}}"
    },
    "actions": {
      "confirmBooking": "Buchung bestätigen",
      "confirm": "Bestätigen",
      "rescheduleWithAI": "Mit KI-Agenten umplanen",
      "aiReschedule": "KI-Umplanung",
      "cancelBooking": "Buchung stornieren",
      "cancel": "Stornieren"
    },
    "unconfirmed": {
      "title": "Unbestätigte Buchungen",
      "searchPlaceholder": "Buchungen suchen...",
      "filterPending": "Ausstehend",
      "filterAll": "Alle",
      "pagination": "{{start}}-{{end}} von {{total}} Buchungen"
    },
    "calendar": {
      "title": "Bestätigte Buchungen – Kalender",
      "hint": "Klicken Sie auf eine Buchung, um Details anzuzeigen"
    },
    "details": {
      "title": "Buchungsdetails",
      "description": "Beschreibung:",
      "customer": "Kunde:",
      "dateTime": "Datum & Uhrzeit:"
    },
    "messages": {
      "confirmSuccess": "Buchung erfolgreich bestätigt!",
      "confirmError": "Buchung konnte nicht bestätigt werden",
      "cancelTitle": "Buchung stornieren",
      "cancelContent": "Möchten Sie diese Buchung wirklich stornieren?",
      "cancelOk": "Ja, stornieren",
      "cancelNo": "Nein",
      "cancelSuccess": "Buchung erfolgreich storniert!",
      "cancelError": "Buchung konnte nicht storniert werden"
    }
  },
  "calendar": {
    "messages": {
      "confirmTitle": "Termin bestätigen",
      "confirmContent": "Möchten Sie diesen Termin{{name}} am {{date}} wirklich bestätigen?",
      "confirmOk": "Ja, bestätigen",
      "confirmSuccess": "Termin erfolgreich bestätigt",
      "confirmError": "Termin konnte nicht bestätigt werden",
      "cancelTitle": "Termin stornieren",
      "cancelContent": "Möchten Sie diesen Termin{{name}} am {{date}} wirklich stornieren?",
      "cancelOk": "Ja, stornieren",
      "cancelSuccess": "Termin erfolgreich storniert",
      "cancelError": "Termin konnte nicht storniert werden",
      "deleteTitle": "Termin löschen",
      "deleteContent": "Möchten Sie diesen Termin{{name}} am {{date}} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteOk": "Ja, löschen",
      "deleteSuccess": "Termin erfolgreich gelöscht",
      "deleteError": "Termin konnte nicht gelöscht werden",
      "noShowTitle": "Als Nichterscheinen markieren",
      "noShowContent": "Diesen Termin{{name}} am {{date}} als Kunden-Nichterscheinen markieren?",
      "noShowOk": "Ja, als Nichterscheinen markieren",
      "noShowSuccess": "Termin als Nichterscheinen markiert",
      "noShowError": "Termin konnte nicht als Nichterscheinen markiert werden",
      "withClient": " mit {{name}}"
    }
  },
  "appointmentComponents": {
    "calendarHeader": {
      "title": "Kalender",
      "description": "Termine und Buchungen anzeigen und verwalten.",
      "createAppointment": "Termin hinzufügen"
    },
    "stats": {
      "totalAppointments": "Termine gesamt",
      "scheduled": "Geplant",
      "confirmed": "Bestätigt",
      "upcomingToday": "Heute anstehend"
    },
    "filters": {
      "title": "Filter",
      "status": "Status",
      "allStatuses": "Alle Status",
      "user": "Benutzer",
      "allUsers": "Alle Benutzer",
      "resource": "Ressource",
      "allResources": "Alle Ressourcen",
      "clearFilters": "Filter löschen",
      "actions": "Aktionen",
      "apptCount": "{{count}} Termin",
      "apptCount_plural": "{{count}} Termine",
      "showExternalCalendars": "Externe Kalender anzeigen",
      "loadingExternalEvents": "Externe Kalenderereignisse werden geladen…",
      "noResources": "Keine Ressourcen verfügbar. Fügen Sie eine Ressource hinzu, um den Kalender anzuzeigen.",
      "statusLabels": {
        "SCHEDULED": "Geplant",
        "CONFIRMED": "Bestätigt",
        "PENDING": "Ausstehend",
        "IN_PROGRESS": "In Bearbeitung",
        "CANCELLED": "Storniert",
        "COMPLETED": "Abgeschlossen",
        "NO_SHOW": "Nicht erschienen",
        "SHADOW": "Schatten"
      }
    },
    "calendar": {
      "appointment": {
        "hiddenSuffix": "· versteckt",
        "clientPending": "ausstehend",
        "fallbackTitle": "Termin"
      }
    },
    "externalEvent": {
      "notAvailable": "k. A.",
      "unavailable": "nicht verfügbar",
      "readOnly": "Importiertes Kalenderereignis (nur Lesen)",
      "details": {
        "title": "Externes Kalenderereignis",
        "summary": "Titel",
        "location": "Ort",
        "resource": "Ressource",
        "dateTime": "Datum & Uhrzeit",
        "ends": "Endet um {{time}}",
        "readOnly": "Importiert (nur Lesen)",
        "noSummary": "Kein Titel"
      }
    },
    "conflictAlert": {
      "title": "Terminkonflikt erkannt",
      "description": "Ein externes Kalenderereignis ({{externalLabel}}, {{timeRange}}) überschneidet sich mit einem bestehenden SA-Termin ({{appointmentName}}) am {{weekday}}, {{date}}. Der bestehende Termin wurde nicht storniert — manuelle Klärung erforderlich.",
      "summary": "{{count}} Terminkonflikte zwischen importierten Kalenderereignissen und SA-Terminen erkannt:",
      "item": "{{externalLabel}} ({{timeRange}}) überschneidet sich mit {{appointmentName}} am {{weekday}}, {{date}}.",
      "footer": "Die bestehenden Termine wurden nicht storniert — manuelle Klärung erforderlich."
    },
    "conflictDayBadge": "Konflikt",
    "legend": {
      "title": "Statuslegende:",
      "scheduled": "Geplant (Unbestätigt)",
      "confirmed": "Bestätigt",
      "pending": "Ausstehend",
      "inProgress": "In Bearbeitung",
      "completed": "Abgeschlossen",
      "cancelled": "Storniert",
      "noShow": "Nicht erschienen",
      "externalBlocked": "Extern / Blockiert"
    },
    "jumpToDate": "Zum Datum springen:",
    "addAppointmentOnDay": "Termin hinzufügen",
    "resourceFallback": "Ressource {{id}}",
    "changeRequest": {
      "pendingPanelEmpty": "Keine offenen Kundenänderungsanfragen",
      "pendingHeaderButton": "Offene Anfragen",
      "pendingDrawerTitle": "Offene Änderungsanfragen",
      "review": "Prüfen",
      "reviewTitle": "Änderungsanfrage prüfen",
      "customer": "Kunde",
      "requestType": "Anfrageart",
      "typeReschedule": "Termin verschieben",
      "status": "Status",
      "originalTime": "Ursprünglicher Termin",
      "requestedTime": "Gewünschte Zeit",
      "customerNote": "Kundennotiz",
      "internalRejectNote": "Interne Ablehnungsnotiz",
      "internalRejectNoteHint": "Nur für Mitarbeiter sichtbar",
      "approve": "Genehmigen",
      "reject": "Ablehnen",
      "approvedSuccess": "Änderungsanfrage genehmigt.",
      "rejectedSuccess": "Änderungsanfrage abgelehnt.",
      "approveFailed": "Änderungsanfrage konnte nicht genehmigt werden.",
      "rejectFailed": "Änderungsanfrage konnte nicht abgelehnt werden.",
      "alreadyResolved": "Diese Anfrage wurde bereits bearbeitet.",
      "submittedAgo": "Eingereicht {{time}}",
      "statusApproved": "Genehmigt",
      "statusRejected": "Abgelehnt",
      "appointment": "Termin",
      "internalRejectNotePlaceholder": "Grund für die Ablehnung (optional)"
    },
    "details": {
      "title": "Termindetails",
      "unconfirmedAction": "Unbestätigt – Aktion erforderlich",
      "notes": "Notizen",
      "client": "Kunde:",
      "anonymous": "Anonym",
      "resourceLabel": "Ressource:",
      "durationMinutes": "{{count}} Min.",
      "dateTime": "Datum & Uhrzeit:",
      "ends": "Endet: {{time}}",
      "confirm": "Bestätigen",
      "reschedule": "Verschieben",
      "aiReschedule": "KI-Verschiebung",
      "cancel": "Stornieren",
      "cancelLeadTimeDisabled": "Stornierungen erfordern mindestens {{days}} Tage Vorlauf vor Terminbeginn.",
      "delete": "Löschen",
      "markNoShow": "Als Nichterscheinen markieren",
      "service": {
        "bookingType": "Service-Buchung",
        "loading": "Service wird geladen…",
        "confirmationDirect": "Direktbuchung",
        "confirmationNeedsApproval": "Freigabe erforderlich",
        "assignedResources": "Zugewiesene Ressourcen",
        "primary": "Primär"
      },
      "labels": {
        "client": "Kunde",
        "resource": "Ressource",
        "dateTime": "Datum & Uhrzeit",
        "format": "Format"
      },
      "meeting": {
        "title": "Termin",
        "video": "Video",
        "inPerson": "Vor Ort",
        "moderatorLink": "Moderator-Link",
        "memberLink": "Gast-Link",
        "joinAsModerator": "Als Moderator beitreten",
        "join": "Meeting beitreten",
        "copy": "Link kopieren",
        "copied": "{{link}} in die Zwischenablage kopiert",
        "copyFailed": "Link konnte nicht kopiert werden"
      },
      "notesSection": {
        "empty": "Noch keine Notizen.",
        "add": "Notiz hinzufügen",
        "edit": "Notiz bearbeiten",
        "modalTitle": "Terminnotiz",
        "modalSubtitle": "Interne Notiz für {{client}} · {{date}}",
        "placeholder": "Details, die das Team zu diesem Termin wissen sollte…",
        "save": "Notiz speichern",
        "saved": "Notiz gespeichert",
        "saveError": "Notiz konnte nicht gespeichert werden"
      },
      "close": "Schließen",
      "duration": "{{count}} Min."
    },
    "manualReschedule": {
      "title": "Manuelle Verschiebung",
      "appointmentId": "Termin {{id}}",
      "client": "Kunde",
      "currentTime": "Aktuelle Zeit",
      "duration": "Dauer",
      "durationMinutes": "{{minutes}} Min.",
      "durationLocked": "{{minutes}} Min. (Servicedauer)",
      "service": "Service",
      "primaryResource": "Primäre Ressource",
      "assignedResources": "Zugewiesene Ressourcen",
      "alertTitle": "Termin verschieben",
      "alertDescription": "Wählen Sie ein neues Datum und eine neue Uhrzeit. Der Kunde wird über die Änderung informiert.",
      "alertDescriptionService": "Wählen Sie einen neuen Zeitraum für diese Servicebuchung. Die Dauer ist durch den Service festgelegt; Ressourcen können für die neue Zeit neu zugewiesen werden.",
      "newStartLabel": "Neues Startdatum & Uhrzeit",
      "placeholder": "Datum und Uhrzeit wählen",
      "endTime": "Endzeit",
      "reschedule": "Verschieben",
      "rescheduling": "Wird verschoben…",
      "success": "Termin erfolgreich verschoben",
      "error": "Termin konnte nicht verschoben werden. Bitte versuchen Sie es erneut.",
      "stillChecking": "Verfügbarkeit wird geprüft. Bitte warten.",
      "selectValidTime": "Bitte wählen Sie ein gültiges Datum und eine gültige Uhrzeit.",
      "slotNotAvailable": "Die gewählte Zeit ist nicht verfügbar. Bitte wählen Sie einen anderen Zeitraum.",
      "newTime": "Neue Zeit"
    },
    "resourceLink": {
      "loading": "Laden...",
      "unnamedResource": "Unbenannte Ressource"
    },
    "create": {
      "title": "Termin hinzufügen",
      "success": "Termin erfolgreich erstellt",
      "error": "Termin konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
      "timeslotBooked": "Dieser Zeitraum ist bereits gebucht. Bitte wählen Sie eine andere Zeit.",
      "timeNotAvailable": "Die gewählte Zeit ist nicht verfügbar.",
      "exceptionPeriod": "Buchung während der Ausnahmezeit nicht möglich: {{reason}}",
      "resourceUnavailable": "Ressource nicht verfügbar",
      "validationFailed": "Validierung fehlgeschlagen",
      "resource": {
        "label": "Ressource",
        "required": "Bitte wählen Sie eine Ressource",
        "placeholder": "Ressource auswählen",
        "allServiceLinkedTitle": "Keine Ressourcen für Direktbuchung verfügbar",
        "allServiceLinkedDescription": "Alle Ressourcen sind aktiven Services zugeordnet. Wechseln Sie zu „Service buchen“, um sie zu planen."
      },
      "duration": {
        "label": "Dauer",
        "tooltipWithPolicy": "Termindauer in Minuten. Richtlinie erfordert {{minutes}} Minuten.",
        "tooltip": "Termindauer in Minuten",
        "required": "Bitte geben Sie die Dauer ein",
        "mustBeNumber": "Dauer muss eine Zahl sein",
        "minDuration": "Dauer muss mindestens 5 Minuten betragen",
        "maxDuration": "Dauer darf 8 Stunden nicht überschreiten",
        "policyDuration": "Dauer muss gemäß Ressourcenrichtlinie {{minutes}} Minuten betragen",
        "policyDurationMultiple": "Dauer muss ein Vielfaches von {{minutes}} Minuten sein (z. B. {{minutes}}, 60, 90)",
        "minutes": "Minuten"
      },
      "dateTime": {
        "label": "Startdatum & Uhrzeit",
        "tooltipWithPolicy": "Min. Vorlaufzeit: {{minLead}} Tage, Max. Vorlaufzeit: {{maxLead}} Tage. Ausrichtung: {{alignment}}-Min.-Intervalle.",
        "required": "Bitte wählen Sie Startdatum und -uhrzeit",
        "pastError": "Startzeit darf nicht in der Vergangenheit liegen",
        "minLeadError": "Termine müssen mindestens {{days}} Tage im Voraus gebucht werden",
        "maxLeadError": "Termine können nicht mehr als {{days}} Tage im Voraus gebucht werden",
        "alignmentError": "Startzeit muss auf {{alignment}}-Minuten-Intervalle ausgerichtet sein (z.B. :00, :{{example1}}, :{{example2}} usw.)",
        "maxFutureError": "Startzeit darf nicht mehr als 1 Jahr in der Zukunft liegen",
        "policyNotYetEffective": "Die Richtlinie ist für die gewählte Zeit noch nicht gültig",
        "policyExpired": "Die Richtlinie ist für die gewählte Zeit abgelaufen",
        "placeholder": "Datum und Uhrzeit wählen",
        "selectDay": "Wählen Sie ein Datum, um verfügbare Zeiten zu sehen",
        "noSlotsOnDay": "Keine verfügbaren Zeiten an diesem Tag",
        "availableTimes": "Verfügbare Zeiten",
        "timezoneHint": "Zeiten in {{timezone}}",
        "calendarLegend": "Ausgegraute Tage sind nicht verfügbar. Punkte markieren Tage mit freien Terminen.",
        "loadingSlots": "Verfügbarkeit wird geladen…"
      },
      "timePreview": {
        "placeholder": "Wählen Sie oben Datum & Uhrzeit, um die Vorschau zu sehen"
      },
      "appointmentType": {
        "label": "Terminbesucher",
        "required": "Bitte wählen Sie einen Terminbesucher",
        "registeredUser": "Registrierter Benutzer",
        "anonymousGuest": "Anonym/Gast"
      },
      "customer": {
        "label": "Kunde",
        "required": "Bitte wählen Sie einen Kunden",
        "placeholder": "Registrierten Kunden auswählen",
        "empty": "Keine Portal-Kunden für diesen Mandanten"
      },
      "guest": {
        "name": "Gastname",
        "nameRequired": "Bitte geben Sie den Gastnamen ein",
        "namePlaceholder": "Gastnamen eingeben",
        "phone": "Gasttelefon",
        "phoneRequired": "Bitte geben Sie die Gasttelefonnummer ein",
        "phonePlaceholder": "Telefonnummer eingeben",
        "phoneNumbersOnly": "Telefon darf nur Zahlen enthalten (Ziffern und optional + am Anfang)",
        "phoneInvalid": "Bitte geben Sie eine vollständige, gültige Telefonnummer ein",
        "email": "Gast-E-Mail",
        "emailPlaceholder": "E-Mail-Adresse eingeben",
        "emailRequired": "Bitte geben Sie die E-Mail des Gastes ein",
        "emailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein"
      },
      "notes": {
        "label": "Notizen",
        "help": "Optionale zusätzliche Informationen zu diesem Termin",
        "placeholder": "Fügen Sie zusätzliche Notizen oder Details zu diesem Termin hinzu...",
        "required": "Bitte geben Sie Notizen ein"
      },
      "bookingMode": {
        "label": "Buchungsart",
        "resource": "Ressource buchen",
        "service": "Service buchen",
        "resourceHint": "Zeit auf einer bestimmten Ressource mit freier Dauer planen.",
        "serviceHint": "Einen konfigurierten Service buchen; Dauer und Ressourcen folgen der Service-Einrichtung."
      },
      "service": {
        "label": "Service",
        "required": "Bitte wählen Sie einen Service",
        "placeholder": "Service auswählen",
        "durationTag": "{{count}} Min.",
        "confirmationDirect": "Direkt",
        "confirmationNeedsApproval": "Freigabe",
        "description": "Beschreibung",
        "durationLocked": "{{count}} Minuten (vom Service vorgegeben)",
        "padding": "Pufferzeit",
        "paddingValue": "{{before}} Min. vorher, {{after}} Min. nachher",
        "selectionMode": "Ressourcenzuweisung",
        "selectionAutoAssign": "Ressourcen automatisch zuweisen",
        "selectionClientPrimary": "Kunde wählt Primärressource",
        "bookingStatus": "Nach der Buchung",
        "statusConfirmed": "Wird als Bestätigt angelegt",
        "statusScheduled": "Wird als Geplant angelegt (Freigabe erforderlich)",
        "noServicesTitle": "Keine aktiven Services",
        "noServicesDescription": "Erstellen und aktivieren Sie einen Service vor der Buchung.",
        "noServicesLink": "Services verwalten"
      },
      "primaryResource": {
        "label": "Primärressource",
        "required": "Bitte wählen Sie eine Primärressource",
        "placeholder": "Primärressource auswählen",
        "noCandidates": "Für die Primärrolle dieses Services sind keine aktiven Ressourcen verknüpft."
      },
      "reminder": {
        "label": "Erinnerung erstellen",
        "prefillTitle": "Erinnerung zur Termin-Nachverfolgung"
      },
      "actions": {
        "cancel": "Abbrechen",
        "creating": "Wird erstellt...",
        "checkingAvailability": "Verfügbarkeit wird geprüft...",
        "createAppointment": "Termin erstellen",
        "createConfirmed": "Direkt als bestätigt anlegen"
      },
      "conflicts": {
        "timeslotBooked": "Zeitraum bereits gebucht",
        "timeslotConflict": "Dieser Zeitraum kollidiert mit einem bestehenden Termin:",
        "time": "Zeit:",
        "status": "Status:",
        "selectDifferentTimeOrResource": "Bitte wählen Sie eine andere Zeit oder Ressource.",
        "outsideHours": "Außerhalb der Geschäftszeiten",
        "availableHours": "Verfügbare Zeiten:",
        "selectWithinHours": "Bitte wählen Sie eine Zeit innerhalb der verfügbaren Zeiten der Ressource.",
        "resourceUnavailable": "Ressource nicht verfügbar",
        "exceptionPeriod": "Die gewählte Zeit fällt in eine Ausnahmeperiode:",
        "period": "Zeitraum:",
        "reason": "Grund:",
        "selectDifferentTime": "Bitte wählen Sie eine andere Zeit.",
        "checkingAvailability": "Verfügbarkeit wird geprüft..."
      },
      "sections": {
        "booking": "Buchung",
        "dateTime": "Datum & Uhrzeit",
        "guest": "Gast",
        "details": "Details"
      },
      "format": {
        "label": "Terminformat",
        "required": "Bitte wählen Sie ein Terminformat aus",
        "inPerson": "Vor Ort",
        "video": "Videoanruf"
      }
    },
    "weekdays": {
      "monday": "Montag",
      "tuesday": "Dienstag",
      "wednesday": "Mittwoch",
      "thursday": "Donnerstag",
      "friday": "Freitag",
      "saturday": "Samstag",
      "sunday": "Sonntag"
    },
    "availabilityValidation": {
      "closedDay": "{{weekday}} ist für diese Ressource als geschlossen markiert.",
      "closedLabel": "Geschlossen",
      "outsideHours": "Gewählte Zeit liegt außerhalb der verfügbaren Zeiten für {{weekday}}.",
      "notAvailable": "Nicht verfügbar"
    }
  },
  "customers": {
    "title": "Kunden",
    "description": "Portal-Kunden, die für diesen Mandanten registriert sind. Sie erscheinen nach Einladung und Registrierung.",
    "search": "Kunden suchen",
    "empty": "Noch keine Portal-Kunden. Kunden erscheinen, nachdem sie eine Einladung angenommen und sich registriert haben.",
    "filters": {
      "refresh": "Aktualisieren",
      "customersCount": "{{filtered}} von {{total}}"
    },
    "table": {
      "title": "Kunden",
      "loading": "Kunden werden geladen…",
      "showingRange": "{{start}}–{{end}} von {{total}}",
      "noMatchFilters": "Keine Kunden entsprechen Ihrer Suche",
      "noCustomersHint": "Laden Sie einen Kunden aus dem CRM ein; danach erscheinen sie hier.",
      "clearFilters": "Suche löschen"
    },
    "columns": {
      "name": "Name",
      "email": "E-Mail",
      "phone": "Telefon",
      "membership": "Mitgliedschaft",
      "verified": "Verifiziert",
      "created": "Erstellt",
      "actions": "Aktionen",
      "verifiedEmail": "E-Mail",
      "verifiedPhone": "Telefon"
    },
    "remove": {
      "confirmTitle": "Kunde entfernen?",
      "confirmDesc": "Der Kunde verliert den Zugriff auf diesen Mandanten.",
      "ok": "Entfernen",
      "cancel": "Abbrechen",
      "button": "Entfernen"
    }
  },
  "employees": {
    "title": "Mitarbeiter",
    "description": "Verwalten Sie Teammitglieder, Rollen und Status.",
    "companiesAndEmployees": "Unternehmen / Mitarbeiter",
    "companiesAndEmployeesDescription": "Verwalten Sie Ihre Unternehmen und Teammitglieder.",
    "companyCreateSuccess": "Unternehmen erstellt",
    "companyUpdateSuccess": "Unternehmen aktualisiert",
    "companyDeleteSuccess": "Unternehmen gelöscht",
    "companyDeleteError": "Unternehmen konnte nicht gelöscht werden",
    "roles": {
      "admin": "Admin",
      "manager": "Manager",
      "agent": "Agent",
      "viewer": "Betrachter",
      "employee": "Mitarbeiter",
      "owner": "Eigentümer"
    },
    "statusLabels": {
      "active": "AKTIV",
      "inactive": "INAKTIV"
    },
    "stats": {
      "active": "aktiv",
      "totalMembers": "Mitglieder gesamt"
    },
    "table": {
      "name": "Name",
      "email": "E-Mail",
      "phone": "Telefon",
      "role": "Rolle",
      "tenantRole": "Mandantenrolle",
      "status": "Status",
      "actions": "Aktionen",
      "clearFilters": "Filter löschen",
      "copied": "Kopiert!",
      "copyEmail": "Kopie",
      "filteredFrom": "(gefiltert aus {{total}} insgesamt)",
      "joined": "Beigetreten",
      "loading": "Mitarbeiter werden geladen...",
      "noEmployees": "Noch keine Mitarbeiter",
      "noMatchFilters": "Kein Mitarbeiter entspricht Ihren Filtern",
      "showingRange": "Zeigt {{start}}–{{end}} von {{total}} Mitarbeitern"
    },
    "filters": {
      "searchPlaceholder": "Name, E-Mail oder Telefon suchen",
      "rolePlaceholder": "Rolle",
      "statusPlaceholder": "Status",
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "clearAll": "Filter löschen"
    },
    "actions": {
      "newEmployee": "Neuer Mitarbeiter",
      "inviteEmployee": "Mitarbeiter einladen"
    },
    "modal": {
      "editTitle": "Mitarbeiter bearbeiten",
      "createTitle": "Neuer Mitarbeiter",
      "saveButton": "Speichern",
      "createButton": "Erstellen"
    },
    "form": {
      "fullName": "Vollständiger Name",
      "fullNameRequired": "Bitte vollständigen Namen eingeben",
      "fullNamePlaceholder": "z.B. Max Mustermann",
      "email": "E-Mail",
      "emailRequired": "Bitte gültige E-Mail eingeben",
      "emailPlaceholder": "name@beispiel.de",
      "phone": "Telefon",
      "phonePlaceholder": "Optional",
      "role": "Rolle",
      "status": "Status"
    },
    "messages": {
      "removeSuccess": "Mitarbeiter entfernt",
      "removeError": "Entfernen fehlgeschlagen",
      "updateSuccess": "Mitarbeiter aktualisiert",
      "createSuccess": "Mitarbeiter erstellt",
      "saveError": "Speichern fehlgeschlagen"
    },
    "invite": {
      "cancel": "Stornieren",
      "close": "Schließen",
      "contextTitle": "Laden Sie ein Teammitglied ein",
      "contextTitleCompany": "Einladung für {{company}}",
      "copyLink": "Registrierungslink kopieren",
      "copySuccess": "Link in die Zwischenablage kopiert",
      "description": "Generieren Sie einen Einladungslink, um ein neues Teammitglied hinzuzufügen. \nTeilen Sie den Link mit der Person, die Sie einladen möchten.",
      "generateLink": "Einladungslink generieren",
      "linkDetails": "Einladungslink",
      "roleLabel": "Rolle",
      "successDescription": "Teilen Sie diesen Link mit der Person, die Sie einladen möchten. \nDer Link läuft in 5 Tagen ab.",
      "successTitle": "Einladungslink generiert",
      "title": "Mitarbeiter einladen",
      "tokenError": "Der Einladungslink konnte nicht generiert werden",
      "tokenSuccess": "Einladungslink generiert"
    },
    "noTenantHint": "Kein Mieter ausgewählt",
    "selectClientHint": "Bitte wählen Sie einen Kunden aus der Dropdown-Liste oben aus",
    "tenantRoleEditor": {
      "changeTitle": "Mieterrolle ändern",
      "cancel": "Stornieren",
      "confirmDescription": "Rolle in {{role}} ändern?",
      "confirmTitle": "Bestätigen Sie den Rollenwechsel",
      "current": "Aktuell",
      "editTooltip": "Mieterrolle ändern",
      "editingFor": "Bearbeitungsrolle für",
      "noChanges": "Keine Änderungen zum Speichern",
      "saveChanges": "Änderungen speichern",
      "selectNewRole": "Wählen Sie eine neue Rolle",
      "selectRole": "Bitte wählen Sie eine Rolle aus",
      "updateError": "Die Rolle konnte nicht aktualisiert werden",
      "updateSuccess": "Rolle erfolgreich aktualisiert"
    }
  },
  "companySettings": {
    "title": "Unternehmenseinstellungen",
    "description": "Konfigurieren Sie das Verhalten, die Tools, den Speicher und die Sicherheit Ihres KI-Agenten.",
    "pageDescription": "Konfigurieren Sie die Mandanteneinstellungen für Ihr Unternehmen.",
    "actions": {
      "resetDefaults": "Standardwerte wiederherstellen",
      "save": "Speichern"
    },
    "weeklySummary": {
      "sectionTitle": "Wöchentliche Smart-Assistant-Zusammenfassung",
      "sectionDescription": "Jeden Montag erhält der ausgewählte Empfänger eine kurze Zusammenfassung für den vorherigen Montag–Sonntag. Wochen ohne Interaktionen werden nicht per E-Mail versendet.",
      "sendLabel": "Wöchentliche Zusammenfassung senden",
      "sendHelp": "Der Abmeldelink in der E-Mail steuert denselben Schalter.",
      "recipientLabel": "Empfänger",
      "recipientHelp": "Wählen Sie ein aktives Mitglied dieses Mandanten.",
      "recipientPlaceholder": "Empfänger auswählen",
      "recipientRequired": "Wählen Sie einen Empfänger aus, bevor Sie die wöchentliche Zusammenfassung aktivieren.",
      "languageLabel": "Geschäftssprache",
      "on": "An",
      "off": "Aus",
      "languages": {
        "en": "English",
        "bg": "Български",
        "de": "Deutsch"
      },
      "selectTenant": "Wählen Sie einen Mandanten aus, um die Unternehmenseinstellungen zu konfigurieren.",
      "saveSuccess": "Einstellung für die wöchentliche E-Mail-Zusammenfassung gespeichert.",
      "saveError": "Die Einstellung für die wöchentliche Zusammenfassung konnte nicht gespeichert werden."
    },
    "model": {
      "sectionTitle": "Modell",
      "sectionDescription": "Diese Optionen steuern, wie Ihre KI kommuniziert. Wenn Sie unsicher sind, behalten Sie die Standardwerte — sie sind sicher und freundlich für die meisten Teams.",
      "provider": "Anbieter",
      "providerHelp": "Wer die KI betreibt. Verschiedene Anbieter bieten unterschiedliche Modelle und Preise.",
      "modelName": "Modell",
      "modelNameHelp": "Das spezifische KI-Gehirn. Neuere Modelle denken meist besser, können aber teurer sein.",
      "modelNamePlaceholder": "z.B. gpt-4o, claude-3.5-sonnet",
      "streaming": "Streaming",
      "streamingHelp": "Zeigt die Antwort der KI während des Schreibens an. Fühlt sich für Benutzer schneller an.",
      "temperature": "Temperatur",
      "temperatureHelp": "Wie kreativ die KI sein soll. Niedrig = sachlich und konsistent. Hoch = einfallsreich und vielfältig.",
      "maxTokens": "Max. Token",
      "maxTokensHelp": "Ein weiches Limit für die Antwortlänge. Höhere Werte erlauben längere, detailliertere Antworten.",
      "systemPrompt": "System-Prompt",
      "systemPromptHelp": "Eine kurze Rolle oder Persönlichkeit für Ihre KI. Beispiel: 'Sei präzise und freundlich. Stelle Rückfragen, wenn nötig.'",
      "systemPromptPlaceholder": "Wie soll sich die KI verhalten? Halten Sie es einfach."
    },
    "knowledge": {
      "sectionTitle": "Wissen",
      "sectionDescription": "Entscheiden Sie, ob die KI die Konversation speichern und Antworten in Ihrer Wissensbasis nachschlagen soll.",
      "enableMemory": "Konversation merken",
      "enableMemoryHelp": "Behält den aktuellen Chat-Kontext bei, damit die KI auf Gesagtes zurückgreifen kann.",
      "enableRag": "Firmenwissen nutzen",
      "enableRagHelp": "Lässt die KI Ihre Dokumente/Wissensbasis durchsuchen, um Fragen genau zu beantworten.",
      "ragTopK": "Abzurufende Ergebnisse",
      "ragTopKHelp": "Wie viele passende Dokumente berücksichtigt werden. Beginnen Sie mit 5 — erhöhen Sie, wenn Antworten Details vermissen."
    },
    "messages": {
      "defaultsRestored": "Standardwerte wiederhergestellt",
      "settingsSaved": "Einstellungen gespeichert",
      "validationError": "Beheben Sie Validierungsfehler vor dem Speichern"
    }
  },
  "knowledge": {
    "title": "Wissensdatenbank",
    "description": "Websites, Dokumente und FAQ-Einträge, mit denen Ihre KI-Agenten Fragen beantworten.",
    "selectTenant": "Wählen Sie einen Mandanten, um seine Wissensdatenbank zu verwalten.",
    "stats": {
      "documents": "Dokumente",
      "chunks": "Indizierte Passagen",
      "websites": "Websites",
      "activeJobs": "In Bearbeitung",
      "lastSync": "Letzte Website-Synchronisierung",
      "never": "Nie",
      "failed": "{{count}} fehlgeschlagen",
      "documentsHint": "Aus Websites, Dateien und FAQ",
      "chunksHint": "Durchsuchbar für Ihre KI-Agenten",
      "pagesHint": "{{count}} Seiten gecrawlt",
      "processingHint": "Indizierung läuft…",
      "upToDate": "Alles ist aktuell"
    },
    "tabs": {
      "company": "Unternehmen",
      "websites": "Websites",
      "documents": "Dokumente",
      "text": "Text & FAQ",
      "search": "Testsuche",
      "activity": "Aktivität"
    },
    "status": {
      "source": {
        "IDLE": "Inaktiv",
        "SYNCING": "Synchronisiert",
        "READY": "Bereit",
        "ERROR": "Fehler"
      },
      "document": {
        "PENDING": "Wartend",
        "PROCESSING": "In Bearbeitung",
        "INDEXED": "Indiziert",
        "SKIPPED": "Übersprungen",
        "FAILED": "Fehlgeschlagen"
      },
      "job": {
        "QUEUED": "Wartend",
        "RUNNING": "Läuft",
        "SUCCEEDED": "Erfolgreich",
        "FAILED": "Fehlgeschlagen",
        "CANCELLED": "Abgebrochen"
      }
    },
    "kinds": {
      "WEB_PAGE": "Webseite",
      "FILE": "Datei",
      "TEXT": "Notiz",
      "FAQ": "FAQ"
    },
    "types": {
      "WEBSITE": "Websites",
      "DOCUMENT": "Dokumente",
      "TEXT": "Text & FAQ"
    },
    "jobTypes": {
      "SYNC_SOURCE": "Website-Synchronisierung",
      "INDEX_DOCUMENT": "Indizierung"
    },
    "triggers": {
      "CREATE": "Erstellt",
      "MANUAL": "Manuell",
      "SCHEDULED": "Geplant",
      "UPLOAD": "Upload",
      "EDIT": "Bearbeitung"
    },
    "common": {
      "actions": "Aktionen",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "reindex": "Neu indizieren",
      "download": "Herunterladen",
      "view": "Details",
      "refresh": "Aktualisieren",
      "cancel": "Abbrechen",
      "save": "Speichern",
      "create": "Erstellen",
      "status": "Status",
      "title": "Titel",
      "updated": "Aktualisiert",
      "chunks": "Passagen",
      "searchPlaceholder": "Nach Titel oder URL suchen",
      "allStatuses": "Alle Status",
      "error": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      "reindexQueued": "Neuindizierung eingeplant",
      "deleted": "Gelöscht",
      "saved": "Gespeichert",
      "all": "Alle",
      "noMatches": "Keine Treffer für Ihre Filter.",
      "showMore": "Mehr anzeigen",
      "showLess": "Weniger anzeigen"
    },
    "websites": {
      "add": "Website hinzufügen",
      "empty": "Der Agent lernt aus Ihren Seiten – Leistungen, Preise, Kontaktdaten – und hält sie automatisch aktuell.",
      "columns": {
        "name": "Website",
        "pages": "Seiten",
        "lastSync": "Letzte Synchronisierung",
        "schedule": "Zeitplan",
        "enabled": "Aktiv",
        "content": "Inhalt"
      },
      "sync": "Jetzt synchronisieren",
      "syncQueued": "Synchronisierung eingeplant",
      "syncAlreadyRunning": "Für diese Website läuft bereits eine Synchronisierung",
      "deleteConfirm": "Diese Website löschen?",
      "deleteDescription": "Alle gecrawlten Seiten werden aus der Wissensdatenbank entfernt.",
      "created": "Website hinzugefügt. Der erste Crawl wurde gestartet.",
      "lastError": "Letzter Fehler",
      "failedPages": "{{count}} Seite(n) fehlgeschlagen",
      "pagesCount": "{{count}} Seiten",
      "passagesCount": "{{count}} Passagen",
      "nextSync": "Nächste Synchronisierung {{time}}",
      "intro": "Seiten werden automatisch gecrawlt und nach Ihrem Zeitplan aktuell gehalten.",
      "emptyTitle": "Fügen Sie Ihre Firmenwebsite hinzu"
    },
    "websiteForm": {
      "createTitle": "Website hinzufügen",
      "editTitle": "Website bearbeiten",
      "startUrl": "Start-URL",
      "startUrlHelp": "Der Crawler folgt Links auf derselben Domain ab dieser Seite.",
      "startUrlInvalid": "Geben Sie eine gültige http(s)-URL ein",
      "name": "Anzeigename",
      "namePlaceholder": "Standardmäßig die Domain",
      "schedule": "Automatische Neusynchronisierung",
      "advanced": "Crawl-Einstellungen",
      "maxDepth": "Linktiefe",
      "maxDepthHelp": "Wie viele Klicks von der Startseite entfernt gefolgt wird (0 = nur die Startseite).",
      "maxPages": "Max. Seiten",
      "include": "Nur diese Pfade",
      "includeHelp": "Nur Pfade crawlen, die diesen Mustern entsprechen, z. B. /produkte/*. Leer lassen, um alles zu crawlen.",
      "exclude": "Pfade ausschließen",
      "excludeHelp": "Pfade, die diesen Mustern entsprechen, nie crawlen, z. B. /blog/*.",
      "respectRobots": "robots.txt beachten",
      "useSitemap": "sitemap.xml verwenden",
      "resyncNote": "Geänderte Crawl-Einstellungen starten eine neue Synchronisierung.",
      "respectRobotsHelp": "Überspringt Seiten, die der Websitebetreiber für Crawler gesperrt hat, z. B. Kasse oder Kundenkonto. Empfohlen: eingeschaltet lassen.",
      "useSitemapHelp": "Liest zusätzlich die Liste aller Seiten der Website, damit auch Seiten gefunden werden, die nicht im Menü verlinkt sind. Diese Seiten zählen zu „Max. Seiten“.",
      "maxPagesHelp": "Der Crawl endet nach so vielen Seiten (höchstens 500).",
      "summary": "Tiefe {{depth}} · bis zu {{pages}} Seiten",
      "createButton": "Website erstellen"
    },
    "schedule": {
      "manual": "Nur manuell",
      "daily": "Täglich",
      "weekly": "Wöchentlich",
      "monthly": "Monatlich",
      "everyHours": "Alle {{count}} Std."
    },
    "documents": {
      "uploadTitle": "Dateien hierher ziehen oder klicken",
      "uploadHint": "PDF, DOCX, TXT, MD oder CSV · bis {{size}} MB pro Datei",
      "uploaded": "{{count}} Datei(en) hochgeladen und zur Indizierung eingeplant",
      "rejected": "{{name}} wurde abgelehnt: {{reason}}",
      "tooLarge": "{{name}} ist {{actual}} groß; Dateien dürfen höchstens {{size}} MB groß sein",
      "unsupported": "{{name}} kann nicht hochgeladen werden: nur {{types}}-Dateien werden unterstützt",
      "empty": "Noch keine Dokumente hochgeladen.",
      "columns": {
        "file": "Datei",
        "size": "Größe"
      },
      "deleteConfirm": "Dieses Dokument löschen?",
      "reindexAll": "Alle neu indizieren",
      "reindexAllConfirm": "Alle Dokumente mit der neuesten Extraktion neu verarbeiten?",
      "reindexAllQueued": "{{count}} Dokument(e) zur Neuindizierung eingeplant"
    },
    "text": {
      "addFaq": "FAQ hinzufügen",
      "addNote": "Notiz hinzufügen",
      "empty": "Schreiben Sie FAQ-Einträge und Notizen zu Dingen, die nicht auf Ihrer Website stehen – Richtlinien, Preisdetails, internes Wissen.",
      "faqTitle": "FAQ hinzufügen",
      "noteTitle": "Notiz hinzufügen",
      "editFaq": "FAQ-Eintrag bearbeiten",
      "editNote": "Notiz bearbeiten",
      "question": "Frage",
      "answer": "Antwort",
      "title": "Titel",
      "content": "Inhalt",
      "titleOptional": "Titel (optional)",
      "required": "Dieses Feld ist erforderlich",
      "deleteConfirm": "Diesen Eintrag löschen?",
      "entry": "Eintrag",
      "emptyTitle": "Häufige Fragen direkt beantworten",
      "searchPlaceholder": "Fragen und Notizen durchsuchen",
      "createFaq": "FAQ erstellen",
      "createNote": "Notiz erstellen"
    },
    "detail": {
      "pages": "Seiten",
      "jobs": "Synchronisierungsverlauf",
      "content": "Extrahierter Text",
      "chunks": "Indizierte Passagen",
      "noChunks": "Noch nichts indiziert.",
      "info": "Details",
      "url": "URL",
      "depth": "Tiefe",
      "httpStatus": "HTTP-Status",
      "error": "Fehler",
      "indexedAt": "Indiziert",
      "size": "Größe",
      "kind": "Typ",
      "page": "Seite {{page}}",
      "tokens": "~{{count}} Tokens",
      "truncated": "Die ersten {{count}} Zeichen werden angezeigt.",
      "pageColumn": "Seite",
      "siteWide": "Seitenübergreifend",
      "siteWideHint": "Inhalte, die auf mehreren Seiten wiederholt werden (Kontaktboxen, Teaser, Fußzeilen). Sie werden hier einmal indiziert statt auf jeder Seite."
    },
    "search": {
      "description": "Stellen Sie eine Frage wie ein Kunde. Dies sind die Passagen, die Ihr KI-Agent zur Beantwortung erhält.",
      "placeholder": "z. B. Wie sind Ihre Öffnungszeiten?",
      "run": "Suchen",
      "topK": "Ergebnisse",
      "sources": "Quellen",
      "allSources": "Alle Quellen",
      "empty": "Starten Sie eine Suche, um die Ergebnisse zu prüfen.",
      "noResults": "Keine relevanten Passagen. Der Agent würde sagen, dass er es nicht weiß, statt zu raten.",
      "score": "Relevanz {{score}}",
      "took": "{{count}} Ergebnisse in {{ms}} ms",
      "examples": [
        "Wie sind Ihre Öffnungszeiten?",
        "Welche Leistungen bieten Sie an?",
        "Wie kann ich Sie kontaktieren?"
      ],
      "relevance": {
        "strong": "Starke Übereinstimmung",
        "good": "Gute Übereinstimmung",
        "weak": "Schwache Übereinstimmung",
        "keyword": "Stichwort-Treffer"
      },
      "similarityTooltip": "Semantische Ähnlichkeit {{value}} (0–1)",
      "keywordTooltip": "Ihre Wörter kommen genau vor, aber ohne starke inhaltliche Übereinstimmung"
    },
    "jobs": {
      "empty": "Noch keine Aktivität.",
      "columns": {
        "type": "Auftrag",
        "target": "Quelle / Dokument",
        "trigger": "Auslöser",
        "status": "Status",
        "result": "Ergebnis",
        "started": "Gestartet",
        "duration": "Dauer"
      },
      "summary": "{{indexed}} indiziert · {{unchanged}} unverändert · {{skipped}} übersprungen · {{failed}} fehlgeschlagen · {{removed}} entfernt",
      "attempt": "Versuch {{attempts}}/{{max}}",
      "retryAt": "Neuer Versuch {{time}}"
    },
    "company": {
      "title": "Unternehmensinformationen",
      "description": "Name, Adresse, Kontaktdaten und Öffnungszeiten, mit denen Ihr KI-Agent antwortet (Tool getCompanyInformation). Werden bei jeder Synchronisierung aus den strukturierten Daten und der Kontaktseite Ihrer Website übernommen; Ihre Änderungen haben Vorrang.",
      "edit": "Bearbeiten",
      "editTitle": "Unternehmensinformationen bearbeiten",
      "editHelp": "Änderungen überschreiben die Werte Ihrer Website und bleiben bei künftigen Synchronisierungen erhalten. Felder, die der Website entsprechen, folgen ihr weiterhin automatisch.",
      "resetToWebsite": "Wert der Website verwenden",
      "clear": "Leeren",
      "openingHoursHelp": "Eintrag eingeben und Enter drücken, z. B. „Mo-Fr 08:00-18:00“ oder „Sa geschlossen“.",
      "emptyNoWebsite": "Noch keine Unternehmensinformationen. Fügen Sie Ihre Website hinzu, sie werden dann automatisch ausgelesen.",
      "emptyNoData": "Auf Ihrer Website wurden noch keine Unternehmensinformationen gefunden. Fügen Sie sie über „Bearbeiten“ manuell hinzu.",
      "addWebsite": "Website hinzufügen",
      "extractedFrom": "Übernommen von {{sources}}",
      "origin": {
        "jsonld": "Website-Daten",
        "website": "Kontaktseite",
        "override": "Bearbeitet"
      },
      "fields": {
        "name": "Name",
        "legalName": "Firmenname",
        "address": "Adresse",
        "phones": "Telefon",
        "emails": "E-Mail",
        "fax": "Fax",
        "openingHours": "Öffnungszeiten",
        "website": "Website",
        "socialLinks": "Social Media",
        "areaServed": "Einzugsgebiet",
        "priceRange": "Preisniveau",
        "description": "Beschreibung"
      },
      "address": {
        "street": "Straße und Hausnummer",
        "postalCode": "PLZ",
        "city": "Ort",
        "region": "Region",
        "country": "Land"
      },
      "placeholders": {
        "phones": "Telefonnummer hinzufügen",
        "emails": "E-Mail-Adresse hinzufügen",
        "openingHours": "Öffnungszeiten hinzufügen",
        "socialLinks": "Profil-URL hinzufügen"
      }
    }
  },
  "permissions": {
    "title": "Berechtigungsverwaltung",
    "connectProfiles": {
      "title": "Profile verbinden",
      "description": "Verbinden Sie Ihr Profil mit anderen Diensten, um Ihren Anmeldeprozess zu vereinfachen.",
      "connectGoogle": "Mit Google verbinden",
      "googleSuccess": "Google-Konto erfolgreich verbunden!",
      "googleError": "Verbindung mit Google-Konto fehlgeschlagen"
    },
    "userPermissions": {
      "title": "Benutzerberechtigungen",
      "description": "Verwalten Sie Benutzerrollen und Berechtigungen für Ihre Organisation."
    }
  },
  "shop": {
    "title": "Shop",
    "description": "Betreiben Sie Ihren Online-Shop mit KI-Unterstützung für Versand, Preisgestaltung und Inhalte.",
    "stats": {
      "orders": "Bestellungen",
      "pending": "Ausstehend",
      "paid": "Bezahlt",
      "revenue": "Umsatz"
    },
    "orders": {
      "title": "Bestellungen",
      "searchPlaceholder": "Bestellungen suchen...",
      "filterPending": "Ausstehend",
      "filterPaid": "Bezahlt",
      "filterFulfilled": "Ausgeliefert",
      "filterCancelled": "Storniert",
      "filterAll": "Alle",
      "table": {
        "order": "Bestellung",
        "customer": "Kunde",
        "total": "Gesamt",
        "status": "Status",
        "actions": "Aktionen",
        "items": "{{count}} Artikel"
      },
      "actions": {
        "fulfill": "Ausliefern",
        "cancel": "Stornieren"
      },
      "messages": {
        "fulfilling": "KI bereitet Versandschritte vor...",
        "fulfillSuccess": "Bestellung ausgeliefert. Versandetikett und E-Mail von KI vorbereitet.",
        "cancelTitle": "Bestellung stornieren",
        "cancelContent": "Der Kunde wird benachrichtigt und die Artikel werden wieder eingelagert.",
        "cancelButton": "Bestellung stornieren",
        "cancelling": "KI verfasst Stornierungsemail...",
        "cancelSuccess": "Bestellung storniert und E-Mail gesendet."
      }
    },
    "products": {
      "title": "Produkte",
      "newProduct": "Neues Produkt",
      "table": {
        "product": "Produkt",
        "sku": "Art.-Nr.",
        "price": "Preis",
        "stock": "Bestand",
        "category": "Kategorie",
        "status": "Status",
        "actions": "Aktionen"
      },
      "statusActive": "AKTIV",
      "statusInactive": "INAKTIV",
      "actions": {
        "aiPrice": "KI-Preis",
        "aiDescription": "KI-Beschreibung",
        "edit": "Bearbeiten"
      },
      "drawer": {
        "editTitle": "Produkt bearbeiten",
        "createTitle": "Neues Produkt",
        "cancel": "Abbrechen",
        "save": "Speichern"
      },
      "form": {
        "name": "Name",
        "nameRequired": "Produktname eingeben",
        "namePlaceholder": "z.B. Premium-Hoodie",
        "sku": "Art.-Nr.",
        "skuPlaceholder": "Optional",
        "category": "Kategorie",
        "categoryPlaceholder": "z.B. Merch",
        "price": "Preis",
        "stock": "Bestand"
      },
      "messages": {
        "updateSuccess": "Produkt aktualisiert",
        "createSuccess": "Produkt erstellt",
        "aiAnalyzing": "KI analysiert ähnliche Produkte und Nachfrage...",
        "aiSuggestedPrice": "Vorgeschlagener Preis: ${{price}}"
      },
      "aiDescription": {
        "title": "KI-Produktbeschreibung",
        "body": "Ein sorgfältig gestaltetes Produkt, das Ihre Kunden lieben werden. Klarer Mehrwert, modernes Design und zuverlässige Qualität.",
        "highlights": "Highlights: schnelle Lieferung, einfache Rückgabe und exzellenter Support."
      }
    }
  },
  "tasksProjects": {
    "title": "Aufgaben & Projekte",
    "description": "Planen und verfolgen Sie Arbeit für Ihren KI-Agenten und Ihr Team.",
    "stats": {
      "myOpenTasks": "Meine offenen Aufgaben",
      "teamOpenTasks": "Offene Teamaufgaben",
      "projectsInProgress": "Projekte in Bearbeitung"
    },
    "tabs": {
      "overview": "Übersicht",
      "projects": "Projekte",
      "notifications": "Benachrichtigungen"
    },
    "tasks": {
      "myTasks": "Meine Aufgaben",
      "teamTasks": "Teamaufgaben",
      "addPersonalPlaceholder": "Persönliche Aufgabe hinzufügen",
      "addTeamPlaceholder": "Teamaufgabe hinzufügen",
      "addButton": "Hinzufügen",
      "noTasks": "Keine Aufgaben",
      "statusNotStarted": "Nicht begonnen",
      "statusInProgress": "In Bearbeitung",
      "statusDone": "Erledigt",
      "priorityLow": "Niedrig",
      "priorityMedium": "Mittel",
      "priorityHigh": "Hoch",
      "due": "Fällig {{date}}"
    },
    "projects": {
      "backlog": "Backlog",
      "inProgress": "In Bearbeitung",
      "done": "Erledigt"
    },
    "notifications": {
      "title": "Bevorstehend & Kürzlich"
    }
  },
  "videoMeetings": {
    "title": "Videokonferenzen",
    "description": "Anzeigen und Verwalten von Videokonferenzen mit Ihren Kunden.",
    "stats": {
      "totalMeetings": "Meetings gesamt",
      "scheduled": "Geplant",
      "confirmed": "Bestätigt",
      "today": "Heute"
    },
    "filters": {
      "searchPlaceholder": "Meetings suchen...",
      "statusPlaceholder": "Nach Status filtern",
      "scheduled": "Geplant",
      "confirmed": "Bestätigt",
      "completed": "Abgeschlossen",
      "cancelled": "Storniert",
      "noShow": "Nicht erschienen",
      "startDate": "Startdatum",
      "endDate": "Enddatum",
      "clear": "Zurücksetzen"
    },
    "table": {
      "client": "Kunde",
      "meetingDetails": "Meeting-Details",
      "dateTime": "Datum & Uhrzeit",
      "status": "Status",
      "actions": "Aktionen",
      "minutes": "{{count}} Minuten",
      "anonymous": "Anonym",
      "interviewTitle": "Vorstellungsgespräch: {{position}}",
      "appointmentTitle": "Termin {{id}}",
      "interviewDescription": "Vorstellungsgespräch für die Position: {{position}}",
      "title": "Videomeetings",
      "empty": "Noch keine Videomeetings",
      "noMatchFilters": "Keine Meetings entsprechen Ihren Filtern"
    },
    "actions": {
      "viewDetails": "Details anzeigen",
      "joinMeeting": "Meeting beitreten",
      "copyUrl": "URL kopieren",
      "copyMeetingUrl": "Meeting-URL kopieren"
    },
    "messages": {
      "urlCopied": "Meeting-URL in die Zwischenablage kopiert!",
      "urlCopyFailed": "URL konnte nicht in die Zwischenablage kopiert werden",
      "noMeetingUrl": "Keine Meeting-URL für diesen Termin verfügbar"
    },
    "pagination": "{{start}}-{{end}} von {{total}} Meetings"
  },
  "clients": {
    "title": "Kunden-Leads",
    "description": "Leads verwalten.",
    "addNewLead": "Neuen Lead hinzufügen",
    "stats": {
      "totalLeads": "Leads gesamt",
      "registered": "Registriert",
      "active": "Aktiv",
      "converted": "Konvertiert"
    },
    "filters": {
      "searchPlaceholder": "Nach Name, E-Mail oder Telefon suchen",
      "statusPlaceholder": "Status",
      "sourcePlaceholder": "Quelle",
      "registrationPlaceholder": "Registrierung",
      "clearFilters": "Filter zurücksetzen",
      "export": "Exportieren"
    },
    "status": {
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "converted": "Konvertiert"
    },
    "source": {
      "websiteWidget": "Website-Widget",
      "email": "E-Mail",
      "voiceCall": "Telefonanruf",
      "sms": "SMS",
      "socialMedia": "Soziale Medien",
      "other": "Sonstiges"
    },
    "registration": {
      "registered": "Registriert",
      "unregistered": "Nicht registriert"
    },
    "table": {
      "client": "Kunde",
      "status": "Status",
      "registration": "Registrierung",
      "source": "Quelle",
      "tags": "Tags",
      "lastInteraction": "Letzte Interaktion",
      "actions": "Aktionen"
    },
    "fallback": {
      "anonymousClient": "Anonymer Kunde",
      "unknownClient": "Unbekannter Kunde",
      "noContactInfo": "Keine Kontaktdaten"
    },
    "actions": {
      "viewDetails": "Details anzeigen",
      "edit": "Bearbeiten",
      "register": "Registrieren",
      "delete": "Löschen",
      "viewChatHistory": "Chatverlauf anzeigen",
      "viewMeetingHistory": "Meeting-Verlauf anzeigen"
    },
    "pagination": "{{start}}-{{end}} von {{total}} Leads",
    "modal": {
      "editTitle": "Kunden-Lead bearbeiten",
      "createTitle": "Neuen Kunden-Lead erstellen",
      "updateButton": "Lead aktualisieren",
      "createButton": "Lead erstellen"
    },
    "form": {
      "fullName": "Vollständiger Name",
      "fullNameRequired": "Bitte geben Sie einen Namen ein",
      "fullNamePlaceholder": "Kundennamen eingeben",
      "source": "Quelle",
      "sourceRequired": "Bitte wählen Sie eine Quelle",
      "sourcePlaceholder": "Quelle auswählen",
      "email": "E-Mail-Adresse",
      "emailInvalid": "Bitte geben Sie eine gültige E-Mail ein",
      "emailPlaceholder": "E-Mail-Adresse eingeben",
      "phone": "Telefonnummer",
      "phonePlaceholder": "Telefonnummer eingeben",
      "tags": "Tags",
      "tagsPlaceholder": "Tags eingeben (Enter zum Hinzufügen)"
    },
    "messages": {
      "createSuccess": "Kunden-Lead erfolgreich erstellt!",
      "createError": "Kunden-Lead konnte nicht erstellt werden",
      "updateSuccess": "Kunden-Lead erfolgreich aktualisiert!",
      "updateError": "Kunden-Lead konnte nicht aktualisiert werden",
      "deleteTitle": "Möchten Sie diesen Kunden-Lead wirklich löschen?",
      "deleteContent": "Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteOk": "Ja, löschen",
      "deleteSuccess": "Kunden-Lead erfolgreich gelöscht!",
      "deleteError": "Kunden-Lead konnte nicht gelöscht werden",
      "registerSuccess": "Kunden-Lead erfolgreich registriert!",
      "registerError": "Registrierung des Kunden-Leads fehlgeschlagen"
    },
    "meetingHistory": {
      "title": "Meeting-Verlauf",
      "modalTitle": "Meeting-Verlauf - {{name}}",
      "videoMeeting": "Videokonferenz",
      "inPersonMeeting": "Vor-Ort-Meeting",
      "noAgentAssigned": "Kein Agent zugewiesen",
      "notes": "Notizen:",
      "tags": "Tags:",
      "loading": "Meeting-Verlauf wird geladen...",
      "noHistory": "Kein Meeting-Verlauf für diesen Kunden gefunden.",
      "noHistoryHint": "Meetings erscheinen hier, sobald der Kunde Termine vereinbart hat."
    }
  },
  "clientDetail": {
    "loading": "Kundendetails werden geladen...",
    "notFound": "Kunde nicht gefunden",
    "backToClients": "Zurück zu Kunden",
    "title": "Kundendetails",
    "noContactInfo": "Keine Kontaktdaten verfügbar",
    "lastInteraction": "Letzte Interaktion: {{time}}",
    "channel": "Kanal: {{channel}}",
    "tags": "Tags",
    "chat": {
      "sessions": "Chat-Sitzungen",
      "noSessions": "Noch keine Chat-Sitzungen",
      "aiAssistant": "KI-Assistent",
      "human": "Mensch",
      "chatWith": "Chat mit {{name}}",
      "selectSession": "Wählen Sie eine Chat-Sitzung aus, um Nachrichten anzuzeigen",
      "noMessages": "Keine Nachrichten in dieser Sitzung",
      "selectSessionHint": "Wählen Sie links eine Chat-Sitzung aus, um Nachrichten anzuzeigen",
      "messagePlaceholder": "Ihre Nachricht eingeben...",
      "send": "Senden"
    },
    "actions": {
      "takeOver": "Übernehmen",
      "endSession": "Sitzung beenden"
    },
    "endSessionModal": {
      "title": "Chat-Sitzung beenden",
      "content": "Möchten Sie diese Chat-Sitzung wirklich beenden?",
      "okText": "Sitzung beenden"
    },
    "takeoverModal": {
      "title": "Chat-Sitzung übernehmen",
      "description": "Sie sind dabei, dieses Gespräch vom KI-Agenten zu übernehmen. Der Kunde wird benachrichtigt, dass ein menschlicher Agent seine Anfrage bearbeitet.",
      "yourName": "Ihr Name",
      "yourNameRequired": "Bitte geben Sie Ihren Namen ein",
      "defaultName": "Menschlicher Agent",
      "namePlaceholder": "Ihren Namen eingeben",
      "takeOver": "Übernehmen"
    },
    "messages": {
      "sendError": "Nachricht konnte nicht gesendet werden",
      "endSessionSuccess": "Chat-Sitzung beendet",
      "endSessionError": "Chat-Sitzung konnte nicht beendet werden",
      "takeoverSuccess": "Gespräch erfolgreich übernommen",
      "takeoverError": "Übernahme der Sitzung fehlgeschlagen"
    }
  },
  "threads": {
    "title": "Kommunikations-Threads",
    "description": "Anzeigen und Verwalten von Kommunikations-Threads Ihrer Kunden.",
    "inactivityArchivedHelp": "Webchat-Threads mit 4 Stunden Inaktivität werden automatisch als archiviert markiert.",
    "loadError": "Kommunikation konnte nicht geladen werden",
    "tryAgain": "Erneut versuchen",
    "stats": {
      "totalThreads": "Gesamt-Threads",
      "filtered": "Gefiltert",
      "activeFlows": "Aktive Flows",
      "recent24h": "Kürzlich (24h)"
    },
    "filters": {
      "searchPlaceholder": "Nach Titel, Zusammenfassung oder Flow-Name suchen...",
      "refresh": "Aktualisieren",
      "customDateRange": "Benutzerdefinierter Zeitraum:",
      "today": "Heute",
      "yesterday": "Gestern",
      "thisWeek": "Diese Woche",
      "thisMonth": "Dieser Monat",
      "activeFilters": "Aktive Filter:",
      "searchTag": "Suche: \"{{text}}\"",
      "timeTag": "Zeit: {{label}}",
      "clearAll": "Alle löschen",
      "threadsCount": "{{filtered}} / {{total}} Threads",
      "active": "Aktiv",
      "hidden": "Ausgeblendet ({{count}})"
    },
    "timePresets": {
      "all": "Gesamte Zeit",
      "24h": "Letzte 24h",
      "7d": "Letzte 7 Tage",
      "30d": "Letzte 30 Tage",
      "90d": "Letzte 90 Tage",
      "custom": "Benutzerdefiniert"
    },
    "status": {
      "active": "Aktiv",
      "closed": "Geschlossen",
      "pending": "Ausstehend",
      "archived": "Archiviert",
      "unknown": "Unbekannt"
    },
    "table": {
      "title": "Kommunikations-Threads",
      "thread": "Thread",
      "flow": "Flow",
      "user": "Benutzer",
      "status": "Status",
      "created": "Erstellt",
      "lastUpdated": "Zuletzt aktualisiert",
      "actions": "Aktionen",
      "threadId": "Thread-ID: {{id}}",
      "copyId": "ID kopieren",
      "copied": "Kopiert!",
      "session": "Sitzung: {{id}}",
      "noSession": "Keine Sitzung",
      "flowId": "Flow-ID: {{id}}",
      "userId": "Benutzer-ID: {{id}}",
      "copyUserId": "Benutzer-ID kopieren",
      "anonymous": "Anonym",
      "identified": "Identifiziert",
      "viewConversation": "Konversation anzeigen",
      "view": "Anzeigen",
      "archive": "Archivieren",
      "archiveTooltip": "Diesen Thread archivieren",
      "threadCount": "{{count}} Thread",
      "threadCount_plural": "{{count}} Threads",
      "loading": "Kommunikation wird geladen...",
      "showingRange": "Zeige {{start}}-{{end}} von {{total}} Threads",
      "filteredFrom": "(gefiltert von {{total}})",
      "noMatchFilters": "Keine Threads entsprechen Ihren Filterkriterien",
      "noThreadsFound": "Keine Kommunikations-Threads gefunden",
      "clearFilters": "Filter löschen",
      "hide": "Ausblenden",
      "hideTooltip": "Aus der Liste ausblenden. Der Thread bleibt erhalten und zählt weiter in der Statistik.",
      "showAgain": "Wieder anzeigen",
      "showAgainTooltip": "Diesen Thread wieder in der Hauptliste anzeigen",
      "delete": "Löschen",
      "hideSelected": "Ausblenden ({{count}})",
      "showAgainSelected": "Wieder anzeigen ({{count}})",
      "deleteSelected": "Löschen ({{count}})",
      "hiddenSuccess": "Thread ausgeblendet",
      "shownAgainSuccess": "Thread wieder angezeigt",
      "hideError": "Thread(s) konnten nicht ausgeblendet werden",
      "showAgainError": "Thread(s) konnten nicht wieder angezeigt werden",
      "moreActions": "Weitere Aktionen",
      "hiddenAgo": "Ausgeblendet {{ago}}",
      "noHiddenThreads": "Keine ausgeblendeten Threads. Ausgeblendete Threads zählen weiter in der Statistik und erscheinen wieder, wenn der Kunde erneut schreibt.",
      "hiddenSuccess_plural": "{{count}} Threads ausgeblendet",
      "shownAgainSuccess_plural": "{{count}} Threads wieder angezeigt",
      "sourceWebchat": "Webchat",
      "sourceEmail": "E-Mail",
      "sourcePhone": "Telefon"
    }
  },
  "threadDetail": {
    "notFound": "Thread nicht gefunden",
    "notFoundDescription": "Der Thread wurde möglicherweise gelöscht oder existiert nicht",
    "backToCommunications": "Zurück zur Kommunikation",
    "threadIdCopied": "Thread-ID in die Zwischenablage kopiert",
    "archiveSuccess": "Thread archiviert",
    "archiveError": "Thread konnte nicht archiviert werden",
    "header": {
      "back": "Zurück",
      "conversationThread": "Gesprächs-Thread",
      "copyThreadId": "Thread-ID kopieren",
      "archive": "Archivieren",
      "id": "ID: {{id}}"
    },
    "sidebar": {
      "messages": "Nachrichten",
      "duration": "Dauer",
      "noData": "—",
      "threadDetails": "Thread-Details",
      "summary": "Zusammenfassung",
      "flow": "Flow",
      "flowId": "Flow-ID: {{id}}",
      "noFlowAssigned": "Kein Flow zugewiesen",
      "fromNumber": "Von",
      "toNumber": "An",
      "fromEmail": "Von",
      "toEmail": "An",
      "callStatus": "Anrufstatus",
      "provider": "Anbieter",
      "started": "Gestartet",
      "lastActivity": "Letzte Aktivität",
      "lastMessageBy": "Letzte Nachricht von",
      "noMessagesYet": "Noch keine Nachrichten"
    },
    "message": {
      "toEmail": "An: {{email}}"
    },
    "conversation": {
      "title": "Konversation",
      "messageCount": "{{count}} Nachrichten",
      "updating": "Aktualisieren...",
      "noMessagesTitle": "Noch keine Nachrichten",
      "noMessagesDescription": "Nachrichten erscheinen hier, sobald das Gespräch beginnt"
    },
    "roles": {
      "aiAssistant": "KI-Assistent",
      "user": "Benutzer",
      "system": "System",
      "tool": "Werkzeug",
      "toolResponse": "Werkzeug-Antwort"
    },
    "toolCard": {
      "label": "Werkzeug",
      "details": "Details",
      "rawJson": "Rohes JSON"
    },
    "dateSeparator": {
      "today": "Heute",
      "yesterday": "Gestern"
    },
    "duration": {
      "zero": "0s",
      "daysHours": "{{days}}d {{hours}}h",
      "hoursMinutes": "{{hours}}h {{minutes}}m",
      "minutesSeconds": "{{minutes}}m {{seconds}}s",
      "seconds": "{{seconds}}s"
    }
  },
  "services": {
    "title": "Dienstleistungen",
    "description": "Buchbare Services, Verfügbarkeitsregeln und KI-Anweisungen definieren",
    "addService": "Service hinzufügen",
    "stats": {
      "total": "Services gesamt",
      "active": "Aktiv",
      "inactive": "Inaktiv"
    },
    "loading": "Services werden geladen...",
    "inactiveHint": "Inaktive Services werden im KI-Chat nicht angeboten.",
    "table": {
      "service": "Service",
      "booking": "Buchung",
      "setup": "Einrichtung",
      "duration": "Dauer",
      "confirmation": "Bestätigung",
      "active": "Aktiv",
      "actions": "Aktionen",
      "noRequirements": "Keine Rollen definiert",
      "noMatchFilters": "Keine Services entsprechen den Filtern",
      "noServices": "Noch keine Services",
      "durationMinutes": "{{count}} Min",
      "confirmationDirect": "Direktbuchung",
      "confirmationNeedsApproval": "Genehmigung nötig",
      "selectionAutoShort": "Auto-Zuweisung",
      "selectionClientShort": "Kundenwahl",
      "callbackRequest": "Rückrufanfrage",
      "callbackNoAppointment": "Kein Termin oder Zeitfenster",
      "callbackNoResources": "Keine Planungsressourcen erforderlich",
      "customSchedule": "Eigene Zeiten",
      "resourceHours": "Ressourcenzeiten",
      "rolesCount": "{{count}} Rollen",
      "linkedResources": "{{count}} verknüpft",
      "linkedResourcesDetail": "{{active}} aktiv · {{total}} verknüpft",
      "readinessReady": "Bereit",
      "readinessNoRoles": "Keine Rollen",
      "readinessNoClientContact": "Keine Kundenkontaktdaten",
      "readinessUnderStaffed": "Ressourcen fehlen",
      "verificationRequired": "Verifizierung erforderlich"
    },
    "filters": {
      "title": "Services",
      "searchPlaceholder": "Services suchen...",
      "allStatuses": "Alle Status",
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "servicesCount": "Services",
      "searchTag": "Suche: {{text}}",
      "activeFilters": "Aktive Filter",
      "clearAll": "Filter löschen"
    },
    "tooltips": {
      "manageService": "Service verwalten",
      "deleteService": "Löschen"
    },
    "pagination": "{{start}}-{{end}} von {{total}} Services",
    "activeToggle": {
      "success": "Status aktualisiert",
      "error": "Status konnte nicht aktualisiert werden",
      "noRoles": "Fügen Sie mindestens eine Rolle unter Ressourcen hinzu, bevor Sie diesen Service aktivieren.",
      "noClientContact": "Wählen Sie E-Mail oder Telefon unter Erforderliche Kundendaten, bevor Sie diesen Service aktivieren."
    }
  },
  "serviceModals": {
    "create": {
      "title": "Service hinzufügen",
      "description": "Erstellen Sie den Service mit den Grunddaten.",
      "saveHint": "Nach dem Speichern können Sie Verfügbarkeit, verknüpfte Ressourcen und KI-Anweisungen in den Service-Einstellungen konfigurieren.",
      "createButton": "Service erstellen",
      "successMessage": "Service erstellt",
      "errorMessage": "Erstellen fehlgeschlagen"
    },
    "edit": {
      "title": "Service bearbeiten",
      "description": "Konfiguration aktualisieren",
      "updateButton": "Änderungen speichern",
      "successMessage": "Service aktualisiert",
      "errorMessage": "Aktualisierung fehlgeschlagen",
      "loading": "Wird geladen..."
    },
    "delete": {
      "title": "Service löschen",
      "deleteButton": "Löschen",
      "confirmMessage": "„{{name}}“ wirklich löschen?",
      "successMessage": "Service gelöscht",
      "errorMessage": "Löschen fehlgeschlagen"
    }
  },
  "serviceForm": {
    "sections": {
      "basic": "Grunddaten",
      "availability": "Verfügbarkeit (optional)",
      "requirements": "Ressourcenanforderungen",
      "aiInstructions": "KI-Anweisungen",
      "clientInfo": "Pflichtangaben vom Kunden",
      "linkedResources": "Verknüpfte Ressourcen"
    },
    "name": "Service-Name",
    "nameRequired": "Name eingeben",
    "namePlaceholder": "z. B. Vor-Ort-Bewertung",
    "description": "Beschreibung",
    "descriptionPlaceholder": "Kurzbeschreibung",
    "durationMinutes": "Dauer (Min)",
    "durationRequired": "Dauer in Minuten eingeben",
    "paddingBefore": "Davor (Min)",
    "paddingAfter": "Danach (Min)",
    "paddingBeforeTooltip": "Pufferzeit vor dem Termin",
    "paddingAfterTooltip": "Pufferzeit nach dem Termin",
    "fulfillmentMode": "Erfüllungsart",
    "fulfillmentAppointment": "Termin",
    "fulfillmentCallback": "Rückrufanfrage",
    "fulfillmentAppointmentHelp": "Erstellt einen geplanten Termin anhand von Verfügbarkeit und verknüpften Ressourcen.",
    "fulfillmentCallbackHelp": "Erfasst Name, Telefon und bevorzugte Rückrufzeit. Es wird kein Termin erstellt und keine Verfügbarkeit oder Ressource verwendet.",
    "confirmationMode": "Bestätigung",
    "confirmationModeCallbackHint": "Für Rückrufanfragen nicht relevant — bestätigt bei Einreichung der Anfrage.",
    "confirmationDirect": "Direkt",
    "confirmationNeedsApproval": "Genehmigung erforderlich",
    "selectionMode": "Ressourcenauswahl",
    "selectionAutoAssign": "Automatisch zuweisen",
    "selectionClientPrimary": "Kunde wählt Hauptressource",
    "availabilityHelp": "Alle Tage geschlossen = nur Ressourcen-Arbeitszeiten.",
    "copyMonday": "Montag auf Werktage kopieren",
    "copyMondaySuccess": "Zeiten kopiert",
    "dayOpen": "Geöffnet",
    "requirementsHelp": "Servicerollen und Mengen pro Buchung. Konkrete Ressourcen auf dem Tab Ressourcen verknüpfen.",
    "addRequirement": "Anforderung hinzufügen",
    "quantity": "Menge",
    "primaryChoice": "Kunde wählt diesen Typ",
    "removeRequirement": "Entfernen",
    "aiInstructions": "Anweisungen für den Buchungs-Agenten",
    "aiInstructionsHelp": "Klartext-Anweisungen für die KI.",
    "aiInstructionsPlaceholder": "z. B. Verfügbare Termine anbieten...",
    "clientInfoName": "Name",
    "clientInfoEmail": "E-Mail",
    "clientInfoPhone": "Telefon",
    "clientInfoNotes": "Notizen",
    "clientInfoActivationHelp": "Der Name ist immer erforderlich. E-Mail und Telefon steuern, was Chat/Widget erfasst (und bei Identitätsverifizierung prüft). Wählen Sie mindestens eines vor der Aktivierung. Anrufe nutzen diese E-Mail-/Telefon-Felder nicht.",
    "callbackClientInfoActivationHelp": "Rückrufanfragen erfordern immer Name und Telefon. E-Mail, Notizen und benutzerdefinierte Felder sind optional.",
    "customClientInfoTitle": "Benutzerdefinierte Felder",
    "customClientInfoHelp": "Fügen Sie zusätzliche Kundendatenfelder hinzu, die der Buchungs-Agent erfassen soll. Aktivieren Sie „Erforderlich“, um ein Feld verpflichtend zu machen.",
    "customClientInfoKeyPlaceholder": "Feldname (z. B. companyName)",
    "customClientInfoRequired": "Erforderlich",
    "customClientInfoAdd": "Feld hinzufügen",
    "customClientInfoRemove": "Feld entfernen",
    "requiredVerification": "Identitätsverifizierung erforderlich",
    "requiredVerificationHelp": "Die Felder E-Mail und Telefon gelten nur für Chat/Widget: Nur E-Mail prüft per E-Mail-Code, nur Telefon per SMS-Code, beide folgen der Angabe des Kunden. Anrufe ignorieren diese Felder. Bei erforderlicher Verifizierung gilt: passende Anrufernummer = automatisch bestätigt, sonst Mobilnummer erfragen und SMS-Code senden; Ablehnung verhindert die Buchung.",
    "aliases": "Lokalisierte Namen",
    "aliasesHelp": "Optionale Namen in anderen Sprachen, damit der KI-Agent diesen Service in mehrsprachigen Chats erkennt.",
    "aliasNamePlaceholder": "Servicename in dieser Sprache",
    "isActive": "Aktiv",
    "isActiveHelp": "Inaktive Services sind im KI-Chat ausgeblendet",
    "isActiveOnTitle": "Service ist live",
    "isActiveOffTitle": "Service ist ausgeblendet",
    "isActiveOnHint": "Kunden können diesen Service über den KI-Agenten finden und buchen.",
    "isActiveOffHint": "Aktivieren, wenn der Service im Chat angeboten werden soll.",
    "isActiveNoRolesWarningTitle": "Rollen hinzufügen, bevor Sie live gehen",
    "isActiveNoRolesWarningDescription": "Ein aktiver Service braucht mindestens eine Rolle unter Ressourcen (z. B. barber, Raum). Rollen definieren, Ressourcen verknüpfen und speichern.",
    "isActiveNoClientContactWarningTitle": "Kundendaten hinzufügen, bevor Sie live gehen",
    "isActiveNoClientContactWarningDescription": "Wählen Sie E-Mail oder Telefon unter Erforderliche Kundendaten. Jede Buchung braucht einen Namen plus mindestens eine Kontaktmöglichkeit.",
    "isActiveNoCallbackContactWarningDescription": "Rückrufanfragen erfordern sowohl Name als auch Telefon.",
    "isActiveSwitchOn": "An",
    "isActiveSwitchOff": "Aus",
    "linkedResourcesSummary": "{{active}} aktiv und {{inactive}} inaktiv für „{{type}}“ (benötigt {{required}})",
    "linkedResourcesInsufficient": "Nur {{active}} aktive Ressource(n) für „{{type}}“, benötigt {{required}}.",
    "availabilityEmptyDescription": "Noch keine Service-Zeiten festgelegt. Ressourcen-Arbeitszeiten gelten weiterhin. Wöchentliche Fenster unten konfigurieren.",
    "validation": {
      "primaryChoiceCount": "Genau eine Anforderung muss als Kundenwahl markiert sein.",
      "primaryChoiceQuantity": "Die Kundenwahl muss Menge 1 haben.",
      "clientPrimaryNoRoles": "Fügen Sie mindestens eine Rolle unter Ressourcen hinzu, bevor Sie die Kundenauswahl aktivieren.",
      "activeRequiresRoles": "Fügen Sie mindestens eine Rolle unter Ressourcen hinzu, bevor Sie diesen Service aktivieren.",
      "activeRequiresClientContact": "Wählen Sie E-Mail oder Telefon unter Erforderliche Kundendaten, bevor Sie diesen Service aktivieren.",
      "clientPrimaryConfigureOnResourcesTab": "Öffnen Sie den Tab Ressourcen, markieren Sie genau eine Rolle als Kundenwahl mit Menge 1 und speichern Sie erneut.",
      "requiredVerificationContactRequired": "Wählen Sie E-Mail oder Telefon. Mindestens eines muss aktiviert bleiben, solange die Identitätsverifizierung eingeschaltet ist.",
      "requiredVerificationEmailRequired": "E-Mail muss erforderlich sein, wenn die Verifizierung aktiviert ist.",
      "customClientInfoKeyRequired": "Geben Sie einen Feldnamen ein.",
      "customClientInfoKeyInvalid": "Der Feldname muss 1–128 Zeichen ohne führende oder nachgestellte Leerzeichen haben.",
      "customClientInfoKeyReserved": "Name, E-Mail, Telefon und Notizen sind bereits oben aufgeführt.",
      "customClientInfoKeyDuplicate": "Dieser Feldname wird bereits verwendet.",
      "endAfterStart": "Ende muss nach Beginn liegen",
      "splitNotSupported": "Mittagspausen-Zeitpläne werden für Services nicht unterstützt. Verwenden Sie durchgehende Zeiten oder geschlossen."
    }
  },
  "resources": {
    "title": "Unternehmensressourcen",
    "description": "Verwalten Sie planbare Ressourcen wie Ärzte, Räume, Geräte und Fahrzeuge",
    "addResource": "Ressource hinzufügen",
    "stats": {
      "totalResources": "Ressourcen gesamt",
      "people": "Personen",
      "rooms": "Räume",
      "equipment": "Geräte"
    },
    "table": {
      "resource": "Ressource",
      "translations": "Übersetzungen",
      "serviceRoles": "Servicerollen",
      "noServiceRoles": "Keine",
      "metadata": "Metadaten",
      "created": "Erstellt",
      "actions": "Aktionen",
      "unnamedResource": "Unbenannte Ressource",
      "noMetadata": "Keine Metadaten",
      "moreMetadata": "+{{count}} weitere",
      "viewMetadata": "JSON anzeigen",
      "noMatchFilters": "Keine Ressource entspricht Ihren Filtern",
      "noResources": "Noch keine Ressourcen"
    },
    "filters": {
      "title": "Ressourcen",
      "searchPlaceholder": "Ressourcen suchen...",
      "allTypes": "Alle Typen",
      "person": "Person",
      "room": "Raum",
      "equipment": "Gerät",
      "vehicle": "Fahrzeug",
      "english": "Englisch",
      "bulgarian": "Bulgarisch",
      "spanish": "Spanisch",
      "activeFilters": "Aktive Filter",
      "clearAll": "Filter löschen",
      "language": "Sprache",
      "resourcesCount": "Ressourcen",
      "searchTag": "Suche: {{text}}"
    },
    "tooltips": {
      "editResource": "Ressource bearbeiten",
      "settings": "Einstellungen",
      "deleteResource": "Ressource löschen"
    },
    "pagination": "{{start}}-{{end}} von {{total}} Ressourcen",
    "loading": "Ressourcen werden geladen..."
  },
  "serviceResources": {
    "callbackNotApplicableTitle": "Ressourcen werden für Rückrufanfragen nicht verwendet",
    "callbackNotApplicableDescription": "Ein Rückruf-Service erfasst Kontaktdaten, statt ein Zeitfenster zu reservieren, und benötigt daher keine Rollen oder verknüpften Ressourcen.",
    "sectionTitle": "Rollen & verknüpfte Ressourcen",
    "sectionHelp": "Jede Rolle beschreibt, was dieser Service benötigt (z. B. Barber). Verknüpfen Sie Ressourcen, die jede Rolle erfüllen können.",
    "emptyRoles": "Noch keine Rollen. Fügen Sie eine Rolle hinzu, um Anforderungen und buchbare Ressourcen festzulegen.",
    "addRole": "Rolle hinzufügen",
    "removeRole": "Rolle entfernen",
    "removeRoleConfirm": "Rolle „{{role}}“ entfernen? Verknüpfte Ressourcen werden beim Speichern entfernt.",
    "role": "Servicerolle",
    "roleRequired": "Servicerolle auswählen",
    "rolePlaceholder": "Rolle auswählen",
    "roleLocked": "Entfernen Sie verknüpfte Ressourcen, bevor Sie die Rolle ändern.",
    "createRoleOption": "Neue Rolle erstellen",
    "coverageBadge": "{{active}} / {{required}} aktiv",
    "coverageWarning": "Mindestens {{required}} aktive Ressource(n) für diese Rolle erforderlich.",
    "linkedResources": "Verknüpfte Ressourcen",
    "noLinksYet": "Noch keine Ressourcen für diese Rolle verknüpft.",
    "addResource": "Ressource hinzufügen",
    "addResourcePlaceholder": "Ressource auswählen",
    "linkActive": "Aktiv",
    "removeLink": "Entfernen",
    "noEligibleResources": "Noch keine Ressourcen mit der Rolle „{{role}}“. Weisen Sie diese Rolle beim Erstellen oder Bearbeiten einer Ressource zu.",
    "browseResources": "Ressourcen durchsuchen",
    "primaryRoleHint": "Markieren Sie genau eine Rolle unten als Kundenwahl. Die Menge muss 1 sein.",
    "primaryRoleHintInline": "Kundenauswahl ist aktiv — wählen Sie eine Rolle, die der Kunde bei der Buchung wählt.",
    "newRole": "Neue Rolle",
    "clientChoiceTag": "Kundenwahl",
    "markAsClientChoice": "Kunde wählt diese Rolle",
    "primaryQuantityLocked": "Kundenwahl-Rollen müssen Menge 1 haben.",
    "linkedCount": "{{count}} verknüpft",
    "activeServiceCoverageWarning": "Der Service ist live, aber einige Rollen haben nicht genug aktive Ressourcen. Buchungen können fehlschlagen, bis Sie mehr verknüpfen oder den Service deaktivieren.",
    "activeServiceNoRolesWarningTitle": "Live-Service ohne Rollen",
    "activeServiceNoRolesWarningDescription": "Fügen Sie unten mindestens eine Rolle hinzu und speichern, oder deaktivieren Sie den Service unter Allgemein, bis Rollen konfiguriert sind.",
    "saveLinksError": "Verknüpfte Ressourcen konnten nicht gespeichert werden",
    "unnamedResource": "Unbenannte Ressource"
  },
  "serviceRoles": {
    "manageButton": "Servicerollen",
    "dialogTitle": "Servicerollen",
    "dialogDescription": "Rollen beschreiben, was Ressourcen leisten können (z. B. Barber, Techniker). Services und Ressourcen verbinden sich über diese Rollen.",
    "addRole": "Rolle hinzufügen",
    "addFirstRole": "Erste Rolle erstellen",
    "createTitle": "Rolle hinzufügen",
    "editTitle": "Rolle bearbeiten",
    "createButton": "Rolle erstellen",
    "saveButton": "Änderungen speichern",
    "editButton": "Bearbeiten",
    "deleteButton": "Löschen",
    "deleteTitle": "Rolle löschen",
    "deleteConfirm": "Rolle „{{name}}“ löschen? Dies kann nicht rückgängig gemacht werden.",
    "deleteConflict": "Diese Rolle wird noch von Ressourcen oder Services verwendet. Entfernen Sie zuerst diese Verknüpfungen.",
    "createSuccess": "Rolle erstellt",
    "updateSuccess": "Rolle aktualisiert",
    "deleteSuccess": "Rolle gelöscht",
    "saveError": "Rolle konnte nicht gespeichert werden",
    "deleteError": "Rolle konnte nicht gelöscht werden",
    "empty": "Noch keine Servicerollen",
    "form": {
      "key": "Rollenschlüssel",
      "keyRequired": "Rollenschlüssel ist erforderlich",
      "keyLength": "Schlüssel muss 1–128 Zeichen lang sein",
      "keyPlaceholder": "z. B. barber, ac_technician",
      "keyEditHint": "Der Rollenschlüssel kann nach dem Erstellen nicht geändert werden",
      "name": "Anzeigename",
      "namePlaceholder": "z. B. Barber, Klima-Techniker",
      "description": "Beschreibung",
      "descriptionPlaceholder": "Optionale Beschreibung für Ihr Team"
    },
    "table": {
      "key": "Rolle",
      "description": "Beschreibung",
      "usage": "Nutzung",
      "resources": "{{count}} Ressourcen",
      "services": "{{count}} Services",
      "actions": "Aktionen"
    }
  },
  "serviceRoleGuide": {
    "step1": {
      "title": "Rollen definieren",
      "description": "Erstellen Sie Rollen für Ihr Angebot (z. B. Barber, Techniker, Raum)."
    },
    "step2": {
      "title": "Ressourcen markieren",
      "description": "Weisen Sie jeder buchbaren Ressource Rollen zu, damit Services wissen, was sie nutzen können."
    },
    "step3": {
      "title": "Mit Service verbinden",
      "serviceDescription": "Fügen Sie unten Rollen hinzu und verknüpfen Sie Ressourcen, die jede Rolle erfüllen können.",
      "resourceDescription": "Nach dem Speichern verknüpfen Sie diese Ressource auf dem Tab Ressourcen jedes Services."
    },
    "manageRoles": "Rollen verwalten",
    "browseResources": "Ressourcen durchsuchen",
    "compactHint": "Weisen Sie Servicerollen zu, damit diese Ressource mit Services verknüpft werden kann."
  },
  "serviceSettings": {
    "loading": "Service wird geladen...",
    "notFound": "Service nicht gefunden",
    "backToServices": "Zurück zu Services",
    "saveButton": "Änderungen speichern",
    "saveSuccess": "Service aktualisiert",
    "saveError": "Aktualisierung fehlgeschlagen",
    "tabs": {
      "general": "Allgemein",
      "availability": "Verfügbarkeit",
      "resources": "Ressourcen"
    }
  },
  "resourceSettings": {
    "loading": "Ressource wird geladen...",
    "notFound": "Ressource nicht gefunden",
    "backToResources": "Zurück zu Ressourcen",
    "tabs": {
      "availability": "Verfügbarkeit",
      "exceptions": "Ausnahmen",
      "calendarsSync": "Kalendersynchronisation",
      "policy": "Richtlinie"
    }
  },
  "calendarSync": {
    "caldav": {
      "discovered": "CalDAV-Kalender gefunden.",
      "discoverError": "CalDAV-Kalendersuche fehlgeschlagen.",
      "connectedQueued": "CalDAV verbunden. Die erste Synchronisierung wurde eingeplant.",
      "connectedPending": "CalDAV-Verbindung gespeichert. Einreihen fehlgeschlagen; die regelmäßige Synchronisierung versucht es erneut.",
      "connectError": "CalDAV konnte nicht verbunden werden.",
      "credentialsUpdated": "CalDAV-Zugangsdaten aktualisiert.",
      "credentialsError": "Zugangsdaten konnten nicht aktualisiert werden.",
      "updateError": "CalDAV-Synchronisierung konnte nicht aktualisiert werden.",
      "queued": "Synchronisierung eingeplant.",
      "queueError": "CalDAV-Synchronisierung konnte nicht eingeplant werden.",
      "disconnected": "CalDAV getrennt.",
      "disconnectError": "CalDAV konnte nicht getrennt werden.",
      "title": "CalDAV-Synchronisierung",
      "description": "Wählen Sie, ob Termine gesendet, belegte Zeiten importiert oder beide Richtungen verwendet werden sollen.",
      "direction": "Synchronisierungsrichtung",
      "push": "Senden",
      "pull": "Importieren",
      "both": "Beide",
      "pushDescription": "Sendet lokale Termine an den externen Kalender. Andere externe Ereignisse blockieren keine Verfügbarkeit.",
      "pullDescription": "Importiert externe Ereignisse als Verfügbarkeitssperren. Im externen Kalender werden keine Termine gesendet oder geändert.",
      "bothDescription": "Sendet lokale Termine und importiert andere externe Ereignisse als Verfügbarkeitssperren.",
      "directionImmutable": "Die Richtung wird beim Verbinden gewählt. Zum Ändern trennen Sie die Verbindung und verbinden Sie den Kalender erneut. Bereits exportierte Ereignisse bleiben erhalten.",
      "pullNotice": "Verwalten Sie externe Ereignisse im externen Kalender. Beim Importieren wird der Kalender nur gelesen; Termine werden weder exportiert noch wiederhergestellt.",
      "duplicateWarning": "ICS-Import und CalDAV nicht mit demselben Kalender verbinden; es können doppelte Sperren entstehen.",
      "serverUrl": "https://cloud.example.com",
      "username": "Benutzername",
      "password": "App-Passwort",
      "newPassword": "Neues App-Passwort",
      "discover": "Kalender suchen",
      "connect": "Verbinden",
      "notSynced": "Nicht synchronisiert",
      "enabled": "Aktiviert",
      "disabled": "Deaktiviert",
      "every": "Alle",
      "minutes": "Min.",
      "syncNow": "Jetzt synchronisieren",
      "initialPending": "Die erste Synchronisierung steht aus.",
      "lastSync": "Letzte Synchronisierung: {{time}}",
      "replaceCredentials": "Zugangsdaten ersetzen",
      "disconnectConfirm": "CalDAV trennen? Bereits von Smart Assistant übertragene Ereignisse bleiben im Kalender.",
      "disconnect": "Trennen",
      "loading": "CalDAV-Verbindung wird geladen…",
      "loadError": "CalDAV-Verbindung konnte nicht geladen werden.",
      "retry": "Erneut versuchen",
      "statusSuccess": "Synchronisiert",
      "statusPartial": "Teilweise synchronisiert",
      "statusFailed": "Synchronisierung fehlgeschlagen",
      "cancel": "Abbrechen",
      "ownershipNotice": "SA-Termine in SA verwalten. Externe Änderungen und Löschungen werden bei der Synchronisierung rückgängig gemacht."
    },
    "heroTitle": "Halten Sie Ihre Kalender perfekt synchron",
    "heroDescription": "Nutzen Sie ICS-Technologie, um Terminkonflikte zu vermeiden, indem Sie externe Kalender blockieren und SmartAss-Termine mit externen Apps teilen.",
    "guides": {
      "googleCalendar": "Google Kalender",
      "appleCalendar": "Apple Kalender (iCloud)",
      "outlook": "Microsoft Outlook"
    },
    "import": {
      "title": "Import nach SmartAss",
      "subtitle": "Externe Kalender mit SmartAss synchronisieren",
      "description": "Verbinden Sie externe Kalender-Feeds, damit SmartAss Zeit blockiert, wenn Sie woanders beschäftigt sind.",
      "fullVisibility": "Volle Sichtbarkeit",
      "fullVisibilityHint": "Zeigt Titel und Details von Ereignissen im externen Kalender.",
      "privacyMode": "Datenschutzmodus",
      "privacyModeHint": "Blockiert nur die Zeit; Titel und Orte werden überall ausgeblendet, wo importierte Termine angezeigt werden.",
      "visibilityUpdated": "Sichtbarkeitsmodus aktualisiert.",
      "visibilityUpdateError": "Sichtbarkeitsmodus konnte nicht aktualisiert werden.",
      "colSync": "SYNC",
      "colUrl": "KALENDER-URL",
      "colMode": "MODUS",
      "colActions": "AKTIONEN",
      "urlPlaceholder": "https://example.com/calendar.ics",
      "add": "Hinzufügen",
      "delete": "Löschen",
      "cancel": "Abbrechen",
      "deleteConfirm": "Diesen Kalender-Feed und importierte Blocker entfernen?",
      "invalidUrl": "Bitte geben Sie eine gültige http- oder https-Kalender-URL ein.",
      "addSuccess": "Kalender-Feed hinzugefügt und synchronisiert.",
      "addSuccessWithDelay": "Kalender-Feed hinzugefügt und synchronisiert. Es kann bis zu einer Minute dauern, bis die Ereignisse im Kalender angezeigt werden.",
      "addError": "Kalender-Feed konnte nicht hinzugefügt werden.",
      "syncUpdated": "Sync-Einstellung aktualisiert.",
      "syncUpdateError": "Sync-Einstellung konnte nicht aktualisiert werden.",
      "urlUpdated": "Kalender-URL aktualisiert.",
      "urlUpdateError": "Kalender-URL konnte nicht aktualisiert werden.",
      "deleteSuccess": "Kalender-Feed entfernt.",
      "deleteError": "Kalender-Feed konnte nicht entfernt werden.",
      "howToTitle": "So importieren Sie Ihren Kalender",
      "step1": "Kopieren Sie die ICS-Abonnement-URL aus Ihrer Kalender-App.",
      "step2": "Fügen Sie die URL ein und klicken Sie auf Hinzufügen.",
      "step3": "Aktivieren Sie Sync für automatische Aktualisierung blockierter Zeiten.",
      "step4": "Wählen Sie Volle Sichtbarkeit oder Datenschutzmodus; die Einstellung gilt für alle Nutzer des Feeds.",
      "step5": "Warten Sie auf die erste Synchronisation vor neuen Buchungen.",
      "guidesTitle": "ICS-Feed erhalten"
    },
    "export": {
      "title": "Export aus SmartAss",
      "subtitle": "SmartAss-Termine mit Ihren Kalendern teilen",
      "description": "Erzeugen Sie eine Abonnement-URL, damit externe Kalender SmartAss-Termine anzeigen.",
      "urlPlaceholder": "ICS-URL erscheint hier nach der Aktivierung",
      "activate": "Aktivieren",
      "deactivate": "Deaktivieren",
      "copy": "URL kopieren",
      "download": "ICS herunterladen",
      "activateSuccess": "Export-Feed aktiviert.",
      "activateError": "Export-Feed konnte nicht aktiviert werden.",
      "deactivateSuccess": "Export-Feed deaktiviert.",
      "deactivateError": "Export-Feed konnte nicht deaktiviert werden.",
      "copySuccess": "URL in die Zwischenablage kopiert.",
      "copyError": "URL konnte nicht kopiert werden.",
      "howToTitle": "So nutzen Sie den ICS-Kalender-Feed",
      "step1": "Klicken Sie auf Aktivieren, um Ihre URL zu erzeugen.",
      "step2": "Kopieren Sie die URL und öffnen Sie Ihre Kalender-App.",
      "step3": "Kalender per URL oder Abonnement hinzufügen (kein einmaliger Import).",
      "step4": "Abonnement speichern; die App aktualisiert sich periodisch.",
      "step5": "Änderungen in SmartAss erscheinen beim nächsten Abruf.",
      "guidesTitle": "Einrichtungsanleitungen"
    }
  },
  "resourceModals": {
    "layout": {
      "classificationTitle": "Typ & Rollen",
      "detailsTitle": "Ressourcendetails"
    },
    "create": {
      "title": "Ressource hinzufügen",
      "description": "Fügen Sie eine neue planbare Ressource zu Ihrem Unternehmen hinzu",
      "tabSimple": "Einfach",
      "tabAdvanced": "Erweitert",
      "createButton": "Ressource erstellen",
      "successMessage": "Ressource mit Standard-Buchungsrichtlinie und Arbeitszeiten erstellt. Sie können diese in den Ressourceneinstellungen anpassen.",
      "errorMessage": "Fehler beim Erstellen der Ressource",
      "translationRequired": "Bitte fügen Sie mindestens eine Übersetzung hinzu",
      "defaultsPreview": {
        "title": "Wird beim Erstellen automatisch konfiguriert",
        "policyTitle": "Buchungsrichtlinie",
        "policySummary": "30 Min. Termine, 15 Min. Start-Raster, Buchung bis 90 Tage im Voraus, 24 Std. Stornierungsfrist, 60 Min. Umbuchungsfrist, keine überlappenden Termine.",
        "availabilityTitle": "Arbeitszeiten (Mo–Fr)",
        "availability": {
          "PERSON": "9:00–13:00 und 14:00–18:00 (Freitag bis 17:00). Wochenende geschlossen.",
          "ROOM": "8:00–20:00 (Freitag bis 18:00). Wochenende geschlossen.",
          "EQUIPMENT": "8:00–18:00. Wochenende geschlossen.",
          "VEHICLE": "7:00–19:00. Wochenende geschlossen."
        },
        "editHint": "Richtlinie und Zeiten können Sie nach dem Erstellen jederzeit in den Ressourceneinstellungen ändern."
      }
    },
    "edit": {
      "title": "Ressource bearbeiten",
      "description": "Ressourceninformationen und Übersetzungen aktualisieren",
      "tabSimple": "Einfach",
      "tabAdvanced": "Erweitert",
      "translationsCount": "({{count}} Übersetzungen)",
      "manageTranslations": "Übersetzungen für mehrere Sprachen verwalten",
      "updateButton": "Ressource aktualisieren",
      "successMessage": "Ressource erfolgreich aktualisiert",
      "errorMessage": "Fehler beim Aktualisieren der Ressource",
      "translationRequired": "Bitte fügen Sie mindestens eine Übersetzung hinzu"
    },
    "delete": {
      "title": "Ressource löschen",
      "deleteButton": "Löschen",
      "confirmMessage": "Sind Sie sicher, dass Sie die Ressource \"{{name}}\" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und löscht auch alle zugehörigen Richtlinien, Verfügbarkeitsregeln und Ausnahmen.",
      "successMessage": "Ressource erfolgreich gelöscht",
      "errorMessage": "Fehler beim Löschen der Ressource"
    },
    "serviceRoles": {
      "label": "Servicerollen",
      "placeholder": "Rollen auswählen, die diese Ressource erfüllen kann",
      "help": "Rollen verbinden diese Ressource mit Services. Den Rollenkatalog verwalten Sie auf der Services-Seite."
    },
    "isHidden": {
      "label": "Direkte Buchung ausblenden",
      "tooltip": "Ausgeblendete Ressourcen erscheinen nicht in der KI-Ressourcenliste und können keine Einzeltermine erhalten. Sie können weiterhin automatisch zugewiesen werden, wenn ein Kunde einen Service bucht, der diese Ressource über eine Rolle verknüpft.",
      "help": "Für unterstützende Ressourcen (Geräte, Räume, Assistenten), die nur im Rahmen eines Services gebucht werden sollen.",
      "switchOn": "Ausgeblendet",
      "switchOff": "Sichtbar"
    }
  },
  "resourceForm": {
    "resourceName": "Ressourcenname",
    "resourceNameRequired": "Bitte geben Sie einen Ressourcennamen ein",
    "resourceNameTooltip": "Geben Sie den Namen der Ressource ein, wie er den Benutzern angezeigt wird",
    "resourceNamePlaceholder": "z.B. Dr. John Smith, Konferenzraum A",
    "language": "Sprache",
    "languageRequired": "Bitte wählen Sie eine Sprache",
    "languagePlaceholder": "Sprache auswählen",
    "metadata": "Metadaten (JSON)",
    "metadataTooltip": "Optionales JSON-Objekt für zusätzliche Daten wie Spezialisierung, Lizenz usw.",
    "metadataHelp": "Beispiel: {\"specialization\": \"Zahnarzt\", \"license\": \"DDS-12345\"}",
    "notificationEmail": "Benachrichtigungs-E-Mail",
    "notificationEmailTooltip": "E-Mail-Adresse für Kundenänderungsanfragen bei Terminen mit dieser Ressource",
    "notificationEmailPlaceholder": "z.B. arzt@praxis.example",
    "notificationEmailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein"
  },
  "availability": {
    "callbackNotApplicableTitle": "Verfügbarkeit wird für Rückrufanfragen nicht verwendet",
    "callbackNotApplicableDescription": "Ein Rückruf-Service bietet keine Terminfenster an. Der Kunde gibt eine bevorzugte Rückrufzeit als Freitext an.",
    "day": "Tag",
    "status": "Status",
    "scheduleMode": "Zeitplan",
    "editorTitle": "Wochenstunden",
    "hoursLegend": "Arbeitszeiten",
    "legend": {
      "continuous": "Durchgehend: nur Öffnung und Schließung (mittlere Spalten ungenutzt).",
      "split": "Mittagspause: alle vier Zeiten für Vormittag, Pause und Nachmittag."
    },
    "weekdays": {
      "monday": "Montag",
      "tuesday": "Dienstag",
      "wednesday": "Mittwoch",
      "thursday": "Donnerstag",
      "friday": "Freitag",
      "saturday": "Samstag",
      "sunday": "Sonntag"
    },
    "mode": {
      "closed": "Geschlossen",
      "continuous": "Durchgehend",
      "split": "Mittagspause"
    },
    "split": {
      "open": "Öffnung",
      "lunchStart": "Pause beginnt",
      "lunchEnd": "Pause endet",
      "close": "Schließung"
    },
    "noScheduleTitle": "Kein Verfügbarkeitsplan konfiguriert",
    "noScheduleDescription": "Für diese Ressource ist noch kein Verfügbarkeitsplan konfiguriert. Buchungen können weiterhin vorgenommen werden, es gibt jedoch keine Zeitbeschränkungen. Stellen Sie den wöchentlichen Zeitplan unten ein und klicken Sie auf 'Verfügbarkeitsplan speichern', um Buchungen auf bestimmte Tage und Zeiten zu beschränken.",
    "weeklyScheduleTitle": "Wochenplan",
    "weeklyScheduleDescription": "Wählen Sie Geschlossen, Durchgehend (ein Zeitblock) oder Mittagspause (Vormittag und Nachmittag). Mittagspause speichert zwei Verfügbarkeitsregeln pro Tag, passend zu geteilten Schichten bei Personen-Ressourcen.",
    "open": "Geöffnet",
    "closed": "Geschlossen",
    "start": "Beginn",
    "end": "Ende",
    "startTimePlaceholder": "Startzeit",
    "endTimePlaceholder": "Endzeit",
    "required": "Erforderlich",
    "validation": {
      "required": "Bitte alle Zeiten angeben",
      "endAfterStart": "Ende muss nach dem Beginn liegen",
      "lunchStartAfterOpen": "Pausenbeginn muss nach der Öffnung liegen",
      "lunchEndAfterLunchStart": "Pausenende muss nach Pausenbeginn liegen",
      "closeAfterLunchEnd": "Schließung muss nach Pausenende liegen"
    },
    "copyMondayToWeekdays": "Montag auf Di–Fr kopieren",
    "copyMondaySuccess": "Montagsplan auf Dienstag bis Freitag kopiert",
    "extraWindowsWarning": "Einige Tage hatten mehr als zwei Zeitfenster; nur die ersten beiden werden als Mittagspause angezeigt.",
    "saveButton": "Verfügbarkeitsplan speichern",
    "resetButton": "Zurücksetzen",
    "successMessage": "Verfügbarkeit erfolgreich aktualisiert",
    "errorMessage": "Fehler beim Aktualisieren der Verfügbarkeit"
  },
  "exceptions": {
    "alertTitle": "Zeitausnahmen",
    "alertDescription": "Fügen Sie Ausnahmen für bestimmte Daten hinzu, an denen die Ressource nicht verfügbar ist (Feiertage, Wartung, besondere Ereignisse). Buchungen können weiterhin ohne Ausnahmen vorgenommen werden, aber das Hinzufügen blockiert Termine in diesen Zeiträumen.",
    "addTitle": "Ausnahme hinzufügen",
    "existingTitle": "Bestehende Ausnahmen",
    "unavailablePeriod": "Nichtverfügbarer Zeitraum",
    "unavailablePeriodRequired": "Bitte wählen Sie einen Datums- und Zeitbereich",
    "reason": "Grund",
    "reasonOptional": "Grund (Optional)",
    "reasonPlaceholder": "z.B. Feiertag, Wartung, Sonderveranstaltung usw.",
    "startDateTime": "Startdatum & Uhrzeit",
    "endDateTime": "Enddatum & Uhrzeit",
    "addButton": "Ausnahme hinzufügen",
    "dateRange": "Datumsbereich",
    "startDate": "Startdatum",
    "endDate": "Enddatum",
    "filterByReason": "Nach Grund filtern...",
    "resetFilters": "Filter zurücksetzen",
    "table": {
      "startTime": "Startzeit",
      "endTime": "Endzeit",
      "reason": "Grund",
      "actions": "Aktionen"
    },
    "today": "Heute",
    "noReason": "Kein Grund",
    "removeTitle": "Ausnahme entfernen",
    "removeConfirm": "Sind Sie sicher, dass Sie diese Ausnahme entfernen möchten?",
    "removeYes": "Ja",
    "removeNo": "Nein",
    "removeButton": "Entfernen",
    "exceptionCount": "{{count}} Ausnahme",
    "exceptionCount_plural": "{{count}} Ausnahmen",
    "ofTotal": " von {{total}}",
    "totalExceptions": "Insgesamt {{total}} Ausnahmen",
    "noExceptionsFound": "Keine Ausnahmen gefunden",
    "invalidMetadata": "Ungültiges JSON im Metadatenfeld",
    "addSuccess": "Ausnahme erfolgreich hinzugefügt",
    "addError": "Fehler beim Hinzufügen der Ausnahme",
    "removeSuccess": "Ausnahme erfolgreich entfernt",
    "removeError": "Fehler beim Entfernen der Ausnahme"
  },
  "policy": {
    "loadingMessage": "Richtlinieneinstellungen werden geladen...",
    "errorTitle": "Fehler beim Laden der Richtlinie",
    "errorDescription": "Richtlinieneinstellungen konnten nicht geladen werden. Bitte aktualisieren Sie die Seite.",
    "refreshButton": "Aktualisieren",
    "noPolicyTitle": "Keine Richtlinie konfiguriert",
    "noPolicyDescription": "Diese Ressource hat noch keine Buchungsrichtlinie. Buchungen können weiterhin vorgenommen werden, verwenden aber Standardbeschränkungen. Konfigurieren Sie die Einstellungen unten und klicken Sie auf 'Richtlinieneinstellungen erstellen', um Planungsregeln, Vorlaufzeiten, Puffer und Stornierungsrichtlinien anzupassen.",
    "configuredTitle": "Buchungsrichtlinien-Konfiguration",
    "configuredDescription": "Konfigurieren Sie Planungsregeln und Einschränkungen für diese Ressource. Diese Einstellungen steuern, wie Termine gebucht werden können, einschließlich Zeitfenster, Vorlaufzeiten, Puffer und Stornierungsrichtlinien.",
    "slotConfig": {
      "title": "Zeitfenster-Konfiguration",
      "description": "Definieren Sie, wie Zeitfenster strukturiert sind",
      "duration": "Zeitfensterdauer",
      "durationTooltip": "Länge jedes Terminfensters in Minuten. Gängige Werte: 15, 30, 45, 60 Minuten.",
      "durationRequired": "Zeitfensterdauer ist erforderlich",
      "durationMin": "Muss mindestens 1 Minute betragen",
      "durationMax": "Darf 1440 Minuten (24 Stunden) nicht überschreiten",
      "alignment": "Zeitfenster-Ausrichtung",
      "alignmentTooltip": "Zeitfenster werden an Intervallen dieser Dauer ausgerichtet (z.B. 15 Minuten = 9:00, 9:15, 9:30...). Sollte ein Teiler der Zeitfensterdauer sein.",
      "alignmentRequired": "Zeitfenster-Ausrichtung ist erforderlich",
      "alignmentMin": "Muss mindestens 1 Minute betragen"
    },
    "leadTime": {
      "title": "Vorlaufzeit-Anforderungen",
      "description": "Steuern Sie, wie weit im Voraus Termine gebucht werden können",
      "minLabel": "Mindestvorlaufzeit",
      "minTooltip": "Mindestzeit im Voraus, zu der Termine gebucht werden können (Minuten, Stunden oder Tage). Auf 0 setzen, um Buchungen am selben Tag zu ermöglichen.",
      "minRequired": "Mindestvorlaufzeit ist erforderlich",
      "maxLabel": "Maximale Vorlaufzeit",
      "maxTooltip": "Maximale Tage im Voraus, an denen Termine gebucht werden können. Verhindert Buchungen zu weit in der Zukunft.",
      "maxRequired": "Maximale Vorlaufzeit ist erforderlich",
      "maxMin": "Muss mindestens 1 Tag betragen"
    },
    "buffer": {
      "title": "Pufferzeiten",
      "description": "Zeitabstände zwischen Terminen hinzufügen",
      "beforeLabel": "Puffer vor dem Termin",
      "beforeTooltip": "Zeitpuffer vor jedem Terminbeginn erforderlich. Nützlich für Vorbereitungszeit.",
      "beforeRequired": "Puffer vorher ist erforderlich",
      "afterLabel": "Puffer nach dem Termin",
      "afterTooltip": "Zeitpuffer nach jedem Terminende erforderlich. Nützlich für Aufräum- oder Reisezeit.",
      "afterRequired": "Puffer nachher ist erforderlich"
    },
    "cancellation": {
      "title": "Stornierung & Umbuchung",
      "description": "Einschränkungen für Änderungen und Stornierungen festlegen",
      "cancelLabel": "Stornierungsvorlaufzeit",
      "cancelTooltip": "Mindestzeit vor dem Termin, zu der eine Stornierung erlaubt ist (Minuten, Stunden oder Tage). Auf 0 setzen, um Stornierungen jederzeit zu ermöglichen.",
      "cancelRequired": "Stornierungsvorlaufzeit ist erforderlich",
      "rescheduleLabel": "Umbuchungsvorlaufzeit",
      "rescheduleTooltip": "Mindestzeit vor dem Termin, zu der eine Umbuchung erlaubt ist (Minuten, Stunden oder Tage). Auf 0 setzen, um Umbuchungen jederzeit zu ermöglichen.",
      "rescheduleRequired": "Umbuchungsvorlaufzeit ist erforderlich"
    },
    "advanced": {
      "title": "Erweiterte Einstellungen",
      "description": "Zusätzliche Konfigurationsoptionen",
      "allowOverlaps": "Überlappende Termine erlauben",
      "allowOverlapsTooltip": "Aktivieren, wenn mehrere Termine gleichzeitig geplant werden können. Nützlich für Gruppensitzungen oder Ressourcen, die mehrere Buchungen gleichzeitig bearbeiten können.",
      "enabled": "Aktiviert",
      "disabled": "Deaktiviert",
      "validityPeriod": "Gültigkeitszeitraum (Optional)",
      "validityPeriodNotice": "Wenn Sie einen Gültigkeitszeitraum festlegen, werden nur innerhalb dieses Datumsbereichs freie Zeitfenster für diese Ressource zurückgegeben. Außerhalb des Zeitraums sind keine freien Zeitfenster verfügbar.",
      "effectiveFrom": "Gültig ab",
      "effectiveFromTooltip": "Wann diese Richtlinie aktiv wird. Leer lassen, um sofort zu starten.",
      "effectiveFromPlaceholder": "Startdatum auswählen",
      "effectiveTo": "Gültig bis",
      "effectiveToTooltip": "Wann diese Richtlinie abläuft. Leer lassen für kein Ablaufdatum.",
      "effectiveToPlaceholder": "Enddatum auswählen"
    },
    "cannotBeNegative": "Darf nicht negativ sein",
    "durationMax": "Darf ein Jahr nicht überschreiten",
    "minutes": "Minuten",
    "hours": "Stunden",
    "days": "Tage",
    "updateButton": "Richtlinieneinstellungen aktualisieren",
    "createButton": "Richtlinieneinstellungen erstellen",
    "resetButton": "Auf Standardwerte zurücksetzen",
    "updateSuccess": "Richtlinie erfolgreich aktualisiert",
    "createSuccess": "Richtlinie erfolgreich erstellt",
    "updateError": "Fehler beim Aktualisieren der Richtlinie. Bitte versuchen Sie es erneut.",
    "resetMessage": "Formular auf Standardwerte zurückgesetzt"
  },
  "companyModal": {
    "editTitle": "Unternehmen bearbeiten",
    "addTitle": "Unternehmen hinzufügen",
    "saveButton": "Änderungen speichern",
    "createButton": "Unternehmen erstellen",
    "companyName": "Firmenname",
    "companyNameRequired": "Bitte geben Sie einen Firmennamen ein",
    "companyNamePlaceholder": "Acme HQ",
    "companyDomain": "Firmen-Domain",
    "companyDomainTooltip": "Optionale Domain, z.B. acme.com",
    "companyDomainPlaceholder": "acme.com",
    "street": "Straße",
    "streetPlaceholder": "Hauptstraße 123",
    "zip": "PLZ / Postleitzahl",
    "zipPlaceholder": "10001",
    "city": "Stadt",
    "cityPlaceholder": "Berlin",
    "country": "Land",
    "countryPlaceholder": "DE",
    "phone": "Telefon",
    "phonePlaceholder": "+49 30 123456",
    "mobile": "Mobil",
    "mobilePlaceholder": "+49 170 1234567",
    "fax": "Fax",
    "faxPlaceholder": "+49 30 123457",
    "email": "E-Mail",
    "emailPlaceholder": "info@acme.com",
    "directions": "Wegbeschreibung",
    "directionsPlaceholder": "Wie Sie dieses Unternehmen / Büro finden (optional)",
    "addDescription": "Neuen Standort oder neue Niederlassung mit Adresse und Kontaktdaten hinzufügen",
    "emailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "sections": {
      "address": "Adresse",
      "contact": "Kontakt"
    }
  },
  "resourceTypeSelector": {
    "label": "Ressourcentyp",
    "required": "Bitte wählen Sie einen Ressourcentyp",
    "placeholder": "Ressourcentyp auswählen",
    "person": "Person",
    "room": "Raum",
    "equipment": "Gerät",
    "vehicle": "Fahrzeug"
  },
  "timezoneSelector": {
    "label": "Zeitzone",
    "required": "Bitte wählen Sie eine Zeitzone",
    "tooltip": "Wählen Sie die Zeitzone, in der sich diese Ressource befindet",
    "placeholder": "Zeitzone suchen..."
  },
  "reminders": {
    "title": "Erinnerungen",
    "description": "Erinnerungen für Sie und Ihr Team anzeigen und verwalten.",
    "loadError": "Erinnerungen konnten nicht geladen werden",
    "tryAgain": "Erneut versuchen",
    "newReminder": "Erinnerung hinzufügen",
    "stats": {
      "total": "Gesamt",
      "active": "Aktiv",
      "notified": "Benachrichtigt",
      "overdue": "Überfällig",
      "done": "Erledigt"
    },
    "filters": {
      "searchPlaceholder": "Nach Titel oder Notiz suchen...",
      "statusPlaceholder": "Alle Status",
      "refresh": "Aktualisieren",
      "clearAll": "Filter löschen",
      "activeFilters": "Aktive Filter:",
      "searchTag": "Suche: \"{{text}}\"",
      "statusTag": "Status: {{status}}",
      "remindersCount": "{{filtered}} / {{total}} Erinnerungen"
    },
    "view": {
      "all": "Alle",
      "active": "Aktiv",
      "notified": "Benachrichtigt",
      "overdue": "Überfällig",
      "done": "Erledigt"
    },
    "status": {
      "active": "Aktiv",
      "notified": "Benachrichtigt",
      "overdue": "Überfällig",
      "done": "Erledigt",
      "cancelled": "Abgebrochen"
    },
    "audience": {
      "TENANT": "Mandant",
      "USER": "Benutzer"
    },
    "modal": {
      "title": "Erinnerung hinzufügen",
      "description": "Planen Sie eine Erinnerung für sich oder Ihr Team.",
      "titleLabel": "Titel",
      "titlePlaceholder": "Woran müssen Sie erinnert werden?",
      "titleRequired": "Titel ist erforderlich",
      "dueLabel": "Fälligkeitsdatum und -zeit",
      "dueRequired": "Fälligkeitsdatum ist erforderlich",
      "dueFuture": "Das Datum muss in der Zukunft liegen",
      "notifyLeadLabel": "Benachrichtigung vor Fälligkeit",
      "notifyLeadRequired": "Bitte wählen Sie, wann benachrichtigt werden soll",
      "notifyLeadWhenDue": "Zum Fälligkeitszeitpunkt",
      "notifyLeadMinutesBefore": "{{count}} Minuten vorher",
      "notifyLeadHoursBefore_one": "{{count}} Stunde vorher",
      "notifyLeadHoursBefore_other": "{{count}} Stunden vorher",
      "notifyLeadDefaultHint": "Ihre Standardeinstellung: {{minutes}} Minuten vorher",
      "levelLabel": "Ebene",
      "levelUser": "Benutzer",
      "levelTenant": "Mandant",
      "levelUserHint": "Sichtbar für Zugewiesenen und Mandanteninhaber",
      "levelTenantHint": "Für alle in Ihrer Organisation sichtbar",
      "assigneeLabel": "Zuweisen an",
      "assigneePlaceholder": "Teammitglied auswählen",
      "assigneeRequired": "Bitte wählen Sie aus, für wen diese Erinnerung gilt",
      "noteLabel": "Notiz",
      "notePlaceholder": "Optionale Details...",
      "save": "Erinnerung erstellen",
      "cancel": "Abbrechen",
      "success": "Erinnerung erfolgreich erstellt",
      "error": "Erinnerung konnte nicht erstellt werden"
    },
    "layout": {
      "table": "Tabelle",
      "calendar": "Kalender",
      "legend": "Status",
      "moreOnDay": "+{{count}} weitere"
    },
    "detail": {
      "title": "Erinnerungsdetails",
      "type": "Typ"
    },
    "table": {
      "title": "Alle Erinnerungen",
      "reminder": "Erinnerung",
      "due": "Fällig",
      "type": "Typ",
      "note": "Notiz",
      "status": "Status",
      "actions": "Aktionen",
      "markDone": "Als erledigt markieren",
      "markDoneConfirmTitle": "Erinnerung als erledigt markieren?",
      "markDoneConfirmDescription": "„{{title}}“ wird als abgeschlossen markiert.",
      "markDoneConfirmOk": "Als erledigt markieren",
      "markDoneConfirmCancel": "Abbrechen",
      "loading": "Erinnerungen werden geladen...",
      "reminderCount": "{{count}} Erinnerung",
      "reminderCount_plural": "{{count}} Erinnerungen",
      "showingRange": "{{start}}–{{end}} von {{total}} Erinnerungen",
      "noMatchFilters": "Keine Erinnerungen entsprechen den Filterkriterien",
      "noRemindersFound": "Noch keine Erinnerungen",
      "noRemindersHint": "Erstellen Sie Erinnerungen für wichtige Aufgaben und Termine.",
      "clearFilters": "Filter löschen",
      "noNote": "Keine Notiz",
      "automaticTag": "Automatisch"
    },
    "bell": {
      "allCaughtUp": "Alles erledigt",
      "needsAttention_one": "{{count}} benötigt Aufmerksamkeit",
      "needsAttention_other": "{{count}} benötigen Aufmerksamkeit",
      "overdueCount_one": "{{count}} überfällig",
      "overdueCount_other": "{{count}} überfällig",
      "noActiveReminders": "Keine aktiven Erinnerungen",
      "newRemindersAppearHere": "Neue Erinnerungen werden hier angezeigt",
      "dueSoon": "Bald fällig",
      "viewAllReminders": "Alle Erinnerungen anzeigen"
    }
  },
  "translationList": {
    "title": "Übersetzungen",
    "defaultExtraText": "Übersetzungen für mehrere Sprachen hinzufügen",
    "selectLanguage": "Sprache auswählen",
    "languagePlaceholder": "Sprache",
    "enterName": "Name eingeben",
    "namePlaceholder": "Ressourcenname in dieser Sprache",
    "addTranslation": "Übersetzung hinzufügen"
  },
  "leadDetail": {
    "backToLeads": "Zurück zu Leads",
    "content": {
      "conversionInfo": "Konvertierung",
      "convertedCustomer": "Konvertierte Kunden-ID",
      "metadata": "Zusätzliche Daten",
      "noMetadata": "Keine zusätzlichen Daten verfügbar.",
      "noNotes": "Es wurden noch keine Notizen hinzugefügt.",
      "notes": "Notizen",
      "statusNotConverted": "Dieser Lead wurde noch nicht konvertiert.",
      "convertButton": "In Kunden umwandeln",
      "convertSuccess": "{{name}} als Kunde angelegt",
      "requestVerification": "Verifizierung von diesem Lead anfordern",
      "requestVerificationSuccess": "Verifizierungsanfrage gesendet",
      "requestVerificationPending": "Für diesen Lead ist bereits eine Verifizierungsanfrage aktiv",
      "requestVerificationError": "Verifizierung konnte nicht angefordert werden"
    },
    "header": {
      "back": "Zurück",
      "copyLeadId": "Lead-ID kopieren",
      "id": "ID: {{id}}",
      "leadProfile": "Lead-Profil"
    },
    "leadIdCopied": "Lead-ID in die Zwischenablage kopiert",
    "loading": "Lead-Details werden geladen...",
    "notFound": "Lead nicht gefunden",
    "notFoundDescription": "Der Lead wurde möglicherweise gelöscht oder existiert nicht.",
    "sidebar": {
      "channel": "Kanal",
      "contactInfo": "Kontaktinformationen",
      "convertedAt": "Konvertierungsstatus",
      "created": "Erstellt",
      "email": "E-Mail",
      "emailNotVerified": "E-Mail nicht bestätigt",
      "emailVerified": "E-Mail bestätigt",
      "lastUpdated": "Zuletzt aktualisiert",
      "noEmail": "Keine E-Mail-Adresse angegeben",
      "noPhone": "Kein Telefon vorhanden",
      "noSession": "Keine Sitzung verknüpft",
      "noThread": "Kein Thread verlinkt",
      "notConverted": "Noch nicht konvertiert",
      "phone": "Telefon",
      "phoneNotVerified": "Telefon nicht bestätigt",
      "phoneVerified": "Telefon verifiziert",
      "source": "Quelle",
      "sourceSession": "Quellsitzung",
      "sourceThread": "Quellthread",
      "timeline": "Zeitleiste",
      "verificationStatus": "Überprüfung",
      "viewThread": "Thread anzeigen",
      "sessionIdentity": "Sitzung & Identität",
      "lastKnownIp": "Letzte bekannte IP",
      "lastKnownUserAgent": "User-Agent",
      "authenticated": "Authentifiziert",
      "authenticatedAt": "Authentifiziert am",
      "authenticatedSessionId": "Authentifizierte Sitzung",
      "fingerprint": "Fingerabdruck",
      "noSessionIdentity": "Keine Sitzungs- oder Identitätsdaten"
    },
    "title": "Lead-Details",
    "contactEdit": {
      "edit": "Bearbeiten",
      "title": "Kontaktdaten bearbeiten",
      "emailLabel": "E-Mail",
      "phoneLabel": "Telefon",
      "phonePlaceholder": "+359888123456",
      "emailInvalid": "Geben Sie eine gültige E-Mail-Adresse ein",
      "phoneInvalid": "Geben Sie eine internationale Nummer ein, z. B. +359888123456",
      "atLeastOne": "Geben Sie eine E-Mail oder eine Telefonnummer ein",
      "verificationWarning": "Wenn Sie die E-Mail oder Telefonnummer ändern, wird deren Bestätigung zurückgesetzt. Ein bereits gesendeter Bestätigungslink an den alten Wert funktioniert dann nicht mehr.",
      "save": "Speichern",
      "success": "Kontaktdaten aktualisiert",
      "error": "Kontaktdaten konnten nicht aktualisiert werden",
      "nothingChanged": "Keine Änderungen zum Speichern"
    }
  },
  "leads": {
    "channel": {
      "CHAT_WIDGET": "Chat-Widget",
      "EMAIL": "E-Mail",
      "OTHER": "Andere",
      "PHONE_CALL": "Telefonanruf",
      "SMS": "SMS",
      "WHATSAPP": "WhatsApp"
    },
    "description": "Verfolgen und verwalten Sie Leads, die über alle Kanäle erfasst wurden.",
    "filters": {
      "activeFilters": "Aktive Filter:",
      "channelPlaceholder": "Alle Kanäle",
      "channelTag": "Kanal: {{channel}}",
      "clearAll": "Alles löschen",
      "leadsCount": "{{filtered}} / {{total}} Leads",
      "refresh": "Aktualisieren",
      "searchPlaceholder": "Suchen Sie nach Name, E-Mail oder Telefon...",
      "searchTag": "Suche: „{{text}}“",
      "statusPlaceholder": "Alle Status",
      "statusTag": "Status: {{status}}"
    },
    "loadError": "Leads konnten nicht geladen werden",
    "stats": {
      "convertedLeads": "Konvertiert",
      "disqualifiedLeads": "Disqualifiziert",
      "newLeads": "Neu",
      "qualifiedLeads": "Qualifiziert",
      "totalLeads": "Gesamtzahl der Leads"
    },
    "status": {
      "CONVERTED": "Konvertiert",
      "DISQUALIFIED": "Disqualifiziert",
      "NEW": "Neu",
      "QUALIFIED": "Qualifiziert"
    },
    "table": {
      "actions": "Aktionen",
      "anonymous": "Anonymer Lead",
      "channel": "Kanal",
      "clearFilters": "Filter löschen",
      "created": "Erstellt",
      "emailVerified": "E-Mail bestätigt",
      "lastUpdated": "Zuletzt aktualisiert",
      "lead": "Führen",
      "leadCount": "{{count}} Lead",
      "leadCount_plural": "{{count}} Leads",
      "loading": "Leads werden geladen...",
      "noContactInfo": "Keine Kontaktinformationen",
      "noLeadsFound": "Es wurden noch keine Leads gefunden",
      "noLeadsHint": "Hier werden Leads angezeigt, die über Ihre Kanäle erfasst werden.",
      "noMatchFilters": "Keine Leads entsprechen Ihren Filterkriterien",
      "notVerified": "Nicht verifiziert",
      "phoneVerified": "Telefon verifiziert",
      "showingRange": "Es werden {{start}}–{{end}} von {{total}} Leads angezeigt",
      "status": "Status",
      "title": "Alle Hinweise",
      "verified": "Verifiziert",
      "view": "Sicht",
      "viewDetails": "Details anzeigen",
      "authenticated": "Per E-Mail-Code authentifiziert",
      "authenticatedShort": "Auth",
      "ip": "IP",
      "convert": "Konvertieren"
    },
    "convert": {
      "convertToCustomer": "In Kunden umwandeln",
      "confirmTitle": "Lead in Kunden umwandeln?",
      "confirmDescription": "Ein Kundenprofil wird aus den Kontakt- und Verifizierungsdaten dieses Leads erstellt.",
      "success": "{{name}} als Kunde angelegt",
      "error": "Lead konnte nicht in einen Kunden umgewandelt werden",
      "requiresVerification": "E-Mail oder Telefon muss vor der Konvertierung verifiziert sein",
      "alreadyConverted": "Dieser Lead wurde bereits konvertiert",
      "converting": "Wird konvertiert..."
    },
    "title": "Leads",
    "tryAgain": "Versuchen Sie es erneut"
  },
  "bulkActions": {
    "selected": "{{count}} ausgewählt",
    "clearSelection": "Auswahl aufheben"
  },
  "deleteEntity": {
    "title": {
      "threads": "{{count}} Thread endgültig löschen?",
      "threads_plural": "{{count}} Threads endgültig löschen?",
      "leads": "{{count}} Lead endgültig löschen?",
      "leads_plural": "{{count}} Leads endgültig löschen?",
      "customers": "{{count}} Kunden endgültig löschen?",
      "customers_plural": "{{count}} Kunden endgültig löschen?"
    },
    "confirm": "Endgültig löschen",
    "delete": "Löschen",
    "deleteTooltip": "Endgültig löschen",
    "deleteSelected": "Löschen ({{count}})",
    "willRemove": "Folgendes wird endgültig entfernt:",
    "nothingFound": "Nichts mehr zu löschen.",
    "irreversible": "Dies kann nicht rückgängig gemacht werden. Gelöschte Elemente werden überall entfernt und zählen nicht mehr in der Statistik. Es wird keine E-Mail oder SMS gesendet.",
    "previewError": "Es konnte nicht ermittelt werden, was gelöscht würde. Es wurde nichts geändert.",
    "success": "{{count}} Element(e) gelöscht",
    "partial": "{{deleted}} von {{total}} gelöscht. Der Rest kann erneut versucht werden.",
    "error": "Löschen fehlgeschlagen. Es wurde nichts geändert.",
    "failedItems": "Diese Elemente konnten nicht gelöscht werden:",
    "counts": {
      "customers": "{{count}} Kunde",
      "customers_plural": "{{count}} Kunden",
      "leads": "{{count}} Lead",
      "leads_plural": "{{count}} Leads",
      "threads": "{{count}} Thread",
      "threads_plural": "{{count}} Threads",
      "messages": "{{count}} Nachricht",
      "messages_plural": "{{count}} Nachrichten",
      "emails": "{{count}} E-Mail",
      "emails_plural": "{{count}} E-Mails",
      "appointments": "{{count}} Termin",
      "appointments_plural": "{{count}} Termine",
      "memberships": "{{count}} Kundenportal-Zugang",
      "memberships_plural": "{{count}} Kundenportal-Zugänge"
    }
  }
}
